// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.4 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-serif: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-300: oklch(80.8% 0.114 19.571);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-red-800: oklch(44.4% 0.177 26.899);
    --color-red-900: oklch(39.6% 0.141 25.723);
    --color-red-950: oklch(25.8% 0.092 26.042);
    --color-orange-50: oklch(98% 0.016 73.684);
    --color-orange-100: oklch(95.4% 0.038 75.164);
    --color-orange-200: oklch(90.1% 0.076 70.697);
    --color-orange-300: oklch(83.7% 0.128 66.29);
    --color-orange-400: oklch(75% 0.183 55.934);
    --color-orange-500: oklch(70.5% 0.213 47.604);
    --color-orange-600: oklch(64.6% 0.222 41.116);
    --color-orange-700: oklch(55.3% 0.195 38.402);
    --color-orange-800: oklch(47% 0.157 37.304);
    --color-orange-900: oklch(40.8% 0.123 38.172);
    --color-orange-950: oklch(26.6% 0.079 36.259);
    --color-amber-50: oklch(98.7% 0.022 95.277);
    --color-amber-100: oklch(96.2% 0.059 95.617);
    --color-amber-200: oklch(92.4% 0.12 95.746);
    --color-amber-300: oklch(87.9% 0.169 91.605);
    --color-amber-400: oklch(82.8% 0.189 84.429);
    --color-amber-500: oklch(76.9% 0.188 70.08);
    --color-amber-600: oklch(66.6% 0.179 58.318);
    --color-amber-700: oklch(55.5% 0.163 48.998);
    --color-amber-800: oklch(47.3% 0.137 46.201);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-amber-950: oklch(27.9% 0.077 45.635);
    --color-yellow-50: oklch(98.7% 0.026 102.212);
    --color-yellow-100: oklch(97.3% 0.071 103.193);
    --color-yellow-200: oklch(94.5% 0.129 101.54);
    --color-yellow-300: oklch(90.5% 0.182 98.111);
    --color-yellow-400: oklch(85.2% 0.199 91.936);
    --color-yellow-500: oklch(79.5% 0.184 86.047);
    --color-yellow-600: oklch(68.1% 0.162 75.834);
    --color-yellow-700: oklch(55.4% 0.135 66.442);
    --color-yellow-800: oklch(47.6% 0.114 61.907);
    --color-yellow-900: oklch(42.1% 0.095 57.708);
    --color-yellow-950: oklch(28.6% 0.066 53.813);
    --color-lime-50: oklch(98.6% 0.031 120.757);
    --color-lime-100: oklch(96.7% 0.067 122.328);
    --color-lime-200: oklch(93.8% 0.127 124.321);
    --color-lime-300: oklch(89.7% 0.196 126.665);
    --color-lime-400: oklch(84.1% 0.238 128.85);
    --color-lime-500: oklch(76.8% 0.233 130.85);
    --color-lime-600: oklch(64.8% 0.2 131.684);
    --color-lime-700: oklch(53.2% 0.157 131.589);
    --color-lime-800: oklch(45.3% 0.124 130.933);
    --color-lime-900: oklch(40.5% 0.101 131.063);
    --color-lime-950: oklch(27.4% 0.072 132.109);
    --color-green-50: oklch(98.2% 0.018 155.826);
    --color-green-100: oklch(96.2% 0.044 156.743);
    --color-green-200: oklch(92.5% 0.084 155.995);
    --color-green-300: oklch(87.1% 0.15 154.449);
    --color-green-400: oklch(79.2% 0.209 151.711);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-700: oklch(52.7% 0.154 150.069);
    --color-green-800: oklch(44.8% 0.119 151.328);
    --color-green-900: oklch(39.3% 0.095 152.535);
    --color-green-950: oklch(26.6% 0.065 152.934);
    --color-emerald-50: oklch(97.9% 0.021 166.113);
    --color-emerald-100: oklch(95% 0.052 163.051);
    --color-emerald-200: oklch(90.5% 0.093 164.15);
    --color-emerald-300: oklch(84.5% 0.143 164.978);
    --color-emerald-400: oklch(76.5% 0.177 163.223);
    --color-emerald-500: oklch(69.6% 0.17 162.48);
    --color-emerald-600: oklch(59.6% 0.145 163.225);
    --color-emerald-700: oklch(50.8% 0.118 165.612);
    --color-emerald-800: oklch(43.2% 0.095 166.913);
    --color-emerald-900: oklch(37.8% 0.077 168.94);
    --color-emerald-950: oklch(26.2% 0.051 172.552);
    --color-teal-50: oklch(98.4% 0.014 180.72);
    --color-teal-100: oklch(95.3% 0.051 180.801);
    --color-teal-200: oklch(91% 0.096 180.426);
    --color-teal-300: oklch(85.5% 0.138 181.071);
    --color-teal-400: oklch(77.7% 0.152 181.912);
    --color-teal-500: oklch(70.4% 0.14 182.503);
    --color-teal-600: oklch(60% 0.118 184.704);
    --color-teal-700: oklch(51.1% 0.096 186.391);
    --color-teal-800: oklch(43.7% 0.078 188.216);
    --color-teal-900: oklch(38.6% 0.063 188.416);
    --color-teal-950: oklch(27.7% 0.046 192.524);
    --color-cyan-50: oklch(98.4% 0.019 200.873);
    --color-cyan-100: oklch(95.6% 0.045 203.388);
    --color-cyan-200: oklch(91.7% 0.08 205.041);
    --color-cyan-300: oklch(86.5% 0.127 207.078);
    --color-cyan-400: oklch(78.9% 0.154 211.53);
    --color-cyan-500: oklch(71.5% 0.143 215.221);
    --color-cyan-600: oklch(60.9% 0.126 221.723);
    --color-cyan-700: oklch(52% 0.105 223.128);
    --color-cyan-800: oklch(45% 0.085 224.283);
    --color-cyan-900: oklch(39.8% 0.07 227.392);
    --color-cyan-950: oklch(30.2% 0.056 229.695);
    --color-sky-50: oklch(97.7% 0.013 236.62);
    --color-sky-100: oklch(95.1% 0.026 236.824);
    --color-sky-200: oklch(90.1% 0.058 230.902);
    --color-sky-300: oklch(82.8% 0.111 230.318);
    --color-sky-400: oklch(74.6% 0.16 232.661);
    --color-sky-500: oklch(68.5% 0.169 237.323);
    --color-sky-600: oklch(58.8% 0.158 241.966);
    --color-sky-700: oklch(50% 0.134 242.749);
    --color-sky-800: oklch(44.3% 0.11 240.79);
    --color-sky-900: oklch(39.1% 0.09 240.876);
    --color-sky-950: oklch(29.3% 0.066 243.157);
    --color-blue-50: oklch(97% 0.014 254.604);
    --color-blue-100: oklch(93.2% 0.032 255.585);
    --color-blue-200: oklch(88.2% 0.059 254.128);
    --color-blue-300: oklch(80.9% 0.105 251.813);
    --color-blue-400: oklch(70.7% 0.165 254.624);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-blue-700: oklch(48.8% 0.243 264.376);
    --color-blue-800: oklch(42.4% 0.199 265.638);
    --color-blue-900: oklch(37.9% 0.146 265.522);
    --color-blue-950: oklch(28.2% 0.091 267.935);
    --color-indigo-50: oklch(96.2% 0.018 272.314);
    --color-indigo-100: oklch(93% 0.034 272.788);
    --color-indigo-200: oklch(87% 0.065 274.039);
    --color-indigo-300: oklch(78.5% 0.115 274.713);
    --color-indigo-400: oklch(67.3% 0.182 276.935);
    --color-indigo-500: oklch(58.5% 0.233 277.117);
    --color-indigo-600: oklch(51.1% 0.262 276.966);
    --color-indigo-700: oklch(45.7% 0.24 277.023);
    --color-indigo-800: oklch(39.8% 0.195 277.366);
    --color-indigo-900: oklch(35.9% 0.144 278.697);
    --color-indigo-950: oklch(25.7% 0.09 281.288);
    --color-violet-50: oklch(96.9% 0.016 293.756);
    --color-violet-100: oklch(94.3% 0.029 294.588);
    --color-violet-200: oklch(89.4% 0.057 293.283);
    --color-violet-300: oklch(81.1% 0.111 293.571);
    --color-violet-400: oklch(70.2% 0.183 293.541);
    --color-violet-500: oklch(60.6% 0.25 292.717);
    --color-violet-600: oklch(54.1% 0.281 293.009);
    --color-violet-700: oklch(49.1% 0.27 292.581);
    --color-violet-800: oklch(43.2% 0.232 292.759);
    --color-violet-900: oklch(38% 0.189 293.745);
    --color-violet-950: oklch(28.3% 0.141 291.089);
    --color-purple-50: oklch(97.7% 0.014 308.299);
    --color-purple-100: oklch(94.6% 0.033 307.174);
    --color-purple-200: oklch(90.2% 0.063 306.703);
    --color-purple-300: oklch(82.7% 0.119 306.383);
    --color-purple-400: oklch(71.4% 0.203 305.504);
    --color-purple-500: oklch(62.7% 0.265 303.9);
    --color-purple-600: oklch(55.8% 0.288 302.321);
    --color-purple-700: oklch(49.6% 0.265 301.924);
    --color-purple-800: oklch(43.8% 0.218 303.724);
    --color-purple-900: oklch(38.1% 0.176 304.987);
    --color-purple-950: oklch(29.1% 0.149 302.717);
    --color-fuchsia-50: oklch(97.7% 0.017 320.058);
    --color-fuchsia-100: oklch(95.2% 0.037 318.852);
    --color-fuchsia-200: oklch(90.3% 0.076 319.62);
    --color-fuchsia-300: oklch(83.3% 0.145 321.434);
    --color-fuchsia-400: oklch(74% 0.238 322.16);
    --color-fuchsia-500: oklch(66.7% 0.295 322.15);
    --color-fuchsia-600: oklch(59.1% 0.293 322.896);
    --color-fuchsia-700: oklch(51.8% 0.253 323.949);
    --color-fuchsia-800: oklch(45.2% 0.211 324.591);
    --color-fuchsia-900: oklch(40.1% 0.17 325.612);
    --color-fuchsia-950: oklch(29.3% 0.136 325.661);
    --color-pink-50: oklch(97.1% 0.014 343.198);
    --color-pink-100: oklch(94.8% 0.028 342.258);
    --color-pink-200: oklch(89.9% 0.061 343.231);
    --color-pink-300: oklch(82.3% 0.12 346.018);
    --color-pink-400: oklch(71.8% 0.202 349.761);
    --color-pink-500: oklch(65.6% 0.241 354.308);
    --color-pink-600: oklch(59.2% 0.249 0.584);
    --color-pink-700: oklch(52.5% 0.223 3.958);
    --color-pink-800: oklch(45.9% 0.187 3.815);
    --color-pink-900: oklch(40.8% 0.153 2.432);
    --color-pink-950: oklch(28.4% 0.109 3.907);
    --color-rose-50: oklch(96.9% 0.015 12.422);
    --color-rose-100: oklch(94.1% 0.03 12.58);
    --color-rose-200: oklch(89.2% 0.058 10.001);
    --color-rose-300: oklch(81% 0.117 11.638);
    --color-rose-400: oklch(71.2% 0.194 13.428);
    --color-rose-500: oklch(64.5% 0.246 16.439);
    --color-rose-600: oklch(58.6% 0.253 17.585);
    --color-rose-700: oklch(51.4% 0.222 16.935);
    --color-rose-800: oklch(45.5% 0.188 13.697);
    --color-rose-900: oklch(41% 0.159 10.272);
    --color-rose-950: oklch(27.1% 0.105 12.094);
    --color-slate-50: oklch(98.4% 0.003 247.858);
    --color-slate-100: oklch(96.8% 0.007 247.896);
    --color-slate-200: oklch(92.9% 0.013 255.508);
    --color-slate-300: oklch(86.9% 0.022 252.894);
    --color-slate-400: oklch(70.4% 0.04 256.788);
    --color-slate-500: oklch(55.4% 0.046 257.417);
    --color-slate-600: oklch(44.6% 0.043 257.281);
    --color-slate-700: oklch(37.2% 0.044 257.287);
    --color-slate-800: oklch(27.9% 0.041 260.031);
    --color-slate-900: oklch(20.8% 0.042 265.755);
    --color-slate-950: oklch(12.9% 0.042 264.695);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-gray-950: oklch(13% 0.028 261.692);
    --color-zinc-50: oklch(98.5% 0 0);
    --color-zinc-100: oklch(96.7% 0.001 286.375);
    --color-zinc-200: oklch(92% 0.004 286.32);
    --color-zinc-300: oklch(87.1% 0.006 286.286);
    --color-zinc-400: oklch(70.5% 0.015 286.067);
    --color-zinc-500: oklch(55.2% 0.016 285.938);
    --color-zinc-600: oklch(44.2% 0.017 285.786);
    --color-zinc-700: oklch(37% 0.013 285.805);
    --color-zinc-800: oklch(27.4% 0.006 286.033);
    --color-zinc-900: oklch(21% 0.006 285.885);
    --color-zinc-950: oklch(14.1% 0.005 285.823);
    --color-neutral-50: oklch(98.5% 0 0);
    --color-neutral-100: oklch(97% 0 0);
    --color-neutral-200: oklch(92.2% 0 0);
    --color-neutral-300: oklch(87% 0 0);
    --color-neutral-400: oklch(70.8% 0 0);
    --color-neutral-500: oklch(55.6% 0 0);
    --color-neutral-600: oklch(43.9% 0 0);
    --color-neutral-700: oklch(37.1% 0 0);
    --color-neutral-800: oklch(26.9% 0 0);
    --color-neutral-900: oklch(20.5% 0 0);
    --color-neutral-950: oklch(14.5% 0 0);
    --color-stone-50: oklch(98.5% 0.001 106.423);
    --color-stone-100: oklch(97% 0.001 106.424);
    --color-stone-200: oklch(92.3% 0.003 48.717);
    --color-stone-300: oklch(86.9% 0.005 56.366);
    --color-stone-400: oklch(70.9% 0.01 56.259);
    --color-stone-500: oklch(55.3% 0.013 58.071);
    --color-stone-600: oklch(44.4% 0.011 73.639);
    --color-stone-700: oklch(37.4% 0.01 67.558);
    --color-stone-800: oklch(26.8% 0.007 34.298);
    --color-stone-900: oklch(21.6% 0.006 56.043);
    --color-stone-950: oklch(14.7% 0.004 49.25);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --breakpoint-sm: 40rem;
    --breakpoint-md: 48rem;
    --breakpoint-lg: 64rem;
    --breakpoint-xl: 80rem;
    --breakpoint-2xl: 96rem;
    --container-3xs: 16rem;
    --container-2xs: 18rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-4xl: 56rem;
    --container-5xl: 64rem;
    --container-6xl: 72rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --text-6xl: 3.75rem;
    --text-6xl--line-height: 1;
    --text-7xl: 4.5rem;
    --text-7xl--line-height: 1;
    --text-8xl: 6rem;
    --text-8xl--line-height: 1;
    --text-9xl: 8rem;
    --text-9xl--line-height: 1;
    --font-weight-thin: 100;
    --font-weight-extralight: 200;
    --font-weight-light: 300;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-extrabold: 800;
    --font-weight-black: 900;
    --tracking-tighter: -0.05em;
    --tracking-tight: -0.025em;
    --tracking-normal: 0em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-normal: 1.5;
    --leading-relaxed: 1.625;
    --leading-loose: 2;
    --radius-xs: 0.125rem;
    --radius-sm: calc(var(--radius) - 4px);
    --radius-md: calc(var(--radius) - 2px);
    --radius-lg: var(--radius);
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --radius-3xl: 1.5rem;
    --radius-4xl: 2rem;
    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);
    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);
    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);
    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);
    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);
    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);
    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);
    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);
    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);
    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);
    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);
    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);
    --text-shadow-sm: 0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),
      0px 2px 2px rgb(0 0 0 / 0.075);
    --text-shadow-md: 0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),
      0px 2px 4px rgb(0 0 0 / 0.1);
    --text-shadow-lg: 0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),
      0px 4px 8px rgb(0 0 0 / 0.1);
    --ease-in: cubic-bezier(0.4, 0, 1, 1);
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --animate-bounce: bounce 1s infinite;
    --blur-xs: 4px;
    --blur-sm: 8px;
    --blur-md: 12px;
    --blur-lg: 16px;
    --blur-xl: 24px;
    --blur-2xl: 40px;
    --blur-3xl: 64px;
    --perspective-dramatic: 100px;
    --perspective-near: 300px;
    --perspective-normal: 500px;
    --perspective-midrange: 800px;
    --perspective-distant: 1200px;
    --aspect-video: 16 / 9;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --font-montserrat: Montserrat, sans-serif;
    --font-press-start: "Press Start 2P", cursive;
    --color-background: hsl(var(--background));
    --color-background-button: hsl(var(--backgroundButton));
    --color-background-button-date: hsl(var(--backgroundButtonDate));
    --color-background-date-picker: var(--backgroundDatePicker);
    --color-background-card: var(--backgroundCard);
    --color-background-invert: var(--backgroundInvert);
    --color-background-secondary: var(--backgroundSecondary);
    --color-background-select: var(--backgroundSelect);
    --color-foreground: hsl(var(--foreground));
    --color-card: hsl(var(--card));
    --color-card-secondary: var(--salmon);
    --color-card-foreground: hsl(var(--card-foreground));
    --color-popover: hsl(var(--popover));
    --color-popover-foreground: hsl(var(--popover-foreground));
    --color-primary: hsl(var(--primary));
    --color-primary-foreground: hsl(var(--primary-foreground));
    --color-secondary: hsl(var(--secondary));
    --color-secondary-foreground: hsl(var(--secondary-foreground));
    --color-muted: hsl(var(--muted));
    --color-muted-foreground: hsl(var(--muted-foreground));
    --color-accent: hsl(var(--accent));
    --color-accent-foreground: hsl(var(--accent-foreground));
    --color-destructive: hsl(var(--destructive));
    --color-destructive-foreground: hsl(var(--destructive-foreground));
    --color-border: hsl(var(--border));
    --color-input: hsl(var(--input));
    --color-ring: hsl(var(--ring));
    --color-chart-1: hsl(var(--chart-1));
    --color-chart-2: hsl(var(--chart-2));
    --color-chart-3: hsl(var(--chart-3));
    --color-chart-4: hsl(var(--chart-4));
    --color-chart-5: hsl(var(--chart-5));
    --color-text-invert: var(--textInvert);
    --color-text-placeholder: var(--textPlaceholder);
    --color-text-primary: hsl(var(--textPrimary));
    --color-text-secondary: hsl(var(--textSecondary));
    --color-text-third: var(--textThird);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .faded-bottom {
    &::after {
      content: var(--tw-content);
      pointer-events: none;
    }
    &::after {
      content: var(--tw-content);
      position: absolute;
    }
    &::after {
      content: var(--tw-content);
      bottom: calc(var(--spacing) * 0);
    }
    &::after {
      content: var(--tw-content);
      left: calc(var(--spacing) * 0);
    }
    &::after {
      content: var(--tw-content);
      display: none;
    }
    &::after {
      content: var(--tw-content);
      height: calc(var(--spacing) * 32);
    }
    &::after {
      content: var(--tw-content);
      width: 100%;
    }
    &::after {
      content: var(--tw-content);
      background-image: linear-gradient(180deg, transparent 10%, hsl(var(--background)) 70%);
    }
    @media (width >= 48rem) {
      &::after {
        content: var(--tw-content);
        display: block;
      }
    }
  }
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .-inset-1 {
    inset: calc(var(--spacing) * -1);
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .-top-1 {
    top: calc(var(--spacing) * -1);
  }
  .-top-4 {
    top: calc(var(--spacing) * -4);
  }
  .-top-6 {
    top: calc(var(--spacing) * -6);
  }
  .-top-\\[46px\\] {
    top: calc(46px * -1);
  }
  .-top-\\[156px\\] {
    top: calc(156px * -1);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1 {
    top: calc(var(--spacing) * 1);
  }
  .top-1\\/2 {
    top: calc(1/2 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-4 {
    top: calc(var(--spacing) * 4);
  }
  .top-\\[-18px\\] {
    top: -18px;
  }
  .top-\\[22px\\] {
    top: 22px;
  }
  .top-\\[50\\%\\] {
    top: 50%;
  }
  .right-1 {
    right: calc(var(--spacing) * 1);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-4 {
    right: calc(var(--spacing) * 4);
  }
  .right-\\[-14px\\] {
    right: -14px;
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .bottom-2 {
    bottom: calc(var(--spacing) * 2);
  }
  .bottom-4 {
    bottom: calc(var(--spacing) * 4);
  }
  .bottom-\\[92px\\] {
    bottom: 92px;
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-1 {
    left: calc(var(--spacing) * 1);
  }
  .left-1\\/2 {
    left: calc(1/2 * 100%);
  }
  .left-2 {
    left: calc(var(--spacing) * 2);
  }
  .left-4 {
    left: calc(var(--spacing) * 4);
  }
  .left-\\[17px\\] {
    left: 17px;
  }
  .left-\\[50\\%\\] {
    left: 50%;
  }
  .isolate {
    isolation: isolate;
  }
  .isolation-auto {
    isolation: auto;
  }
  .z-0 {
    z-index: 0;
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-50 {
    z-index: 50;
  }
  .z-60 {
    z-index: 60;
  }
  .z-70 {
    z-index: 70;
  }
  .z-100 {
    z-index: 100;
  }
  .z-\\[100\\] {
    z-index: 100;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .m-4 {
    margin: calc(var(--spacing) * 4);
  }
  .m-auto {
    margin: auto;
  }
  .-mx-1 {
    margin-inline: calc(var(--spacing) * -1);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-1 {
    margin-block: calc(var(--spacing) * 1);
  }
  .-mt-2 {
    margin-top: calc(var(--spacing) * -2);
  }
  .mt-0 {
    margin-top: calc(var(--spacing) * 0);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-10 {
    margin-top: calc(var(--spacing) * 10);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mr-4 {
    margin-right: calc(var(--spacing) * 4);
  }
  .mr-5 {
    margin-right: calc(var(--spacing) * 5);
  }
  .mb-0 {
    margin-bottom: calc(var(--spacing) * 0);
  }
  .mb-0\\.5 {
    margin-bottom: calc(var(--spacing) * 0.5);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .mb-\\[2px\\] {
    margin-bottom: 2px;
  }
  .mb-\\[10px\\] {
    margin-bottom: 10px;
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-4 {
    margin-left: calc(var(--spacing) * 4);
  }
  .ml-auto {
    margin-left: auto;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .line-clamp-3 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .no-scrollbar {
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .flow-root {
    display: flow-root;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .inline-grid {
    display: inline-grid;
  }
  .inline-table {
    display: inline-table;
  }
  .list-item {
    display: list-item;
  }
  .table {
    display: table;
  }
  .table-caption {
    display: table-caption;
  }
  .table-cell {
    display: table-cell;
  }
  .table-column {
    display: table-column;
  }
  .table-column-group {
    display: table-column-group;
  }
  .table-footer-group {
    display: table-footer-group;
  }
  .table-header-group {
    display: table-header-group;
  }
  .table-row {
    display: table-row;
  }
  .table-row-group {
    display: table-row-group;
  }
  .aspect-3\\/2 {
    aspect-ratio: 3/2;
  }
  .aspect-143\\/135 {
    aspect-ratio: 143/135;
  }
  .aspect-295\\/157 {
    aspect-ratio: 295/157;
  }
  .aspect-366\\/235 {
    aspect-ratio: 366/235;
  }
  .aspect-366\\/361 {
    aspect-ratio: 366/361;
  }
  .aspect-398\\/218 {
    aspect-ratio: 398/218;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .h-0 {
    height: calc(var(--spacing) * 0);
  }
  .h-0\\.5 {
    height: calc(var(--spacing) * 0.5);
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-1\\/2 {
    height: calc(1/2 * 100%);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-11 {
    height: calc(var(--spacing) * 11);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-96 {
    height: calc(var(--spacing) * 96);
  }
  .h-\\[2px\\] {
    height: 2px;
  }
  .h-\\[17px\\] {
    height: 17px;
  }
  .h-\\[26px\\] {
    height: 26px;
  }
  .h-\\[28px\\] {
    height: 28px;
  }
  .h-\\[33px\\] {
    height: 33px;
  }
  .h-\\[34px\\] {
    height: 34px;
  }
  .h-\\[46px\\] {
    height: 46px;
  }
  .h-\\[49px\\] {
    height: 49px;
  }
  .h-\\[60px\\] {
    height: 60px;
  }
  .h-\\[82px\\] {
    height: 82px;
  }
  .h-\\[88px\\] {
    height: 88px;
  }
  .h-\\[100\\%\\] {
    height: 100%;
  }
  .h-\\[100vh\\] {
    height: 100vh;
  }
  .h-\\[146px\\] {
    height: 146px;
  }
  .h-\\[228px\\] {
    height: 228px;
  }
  .h-\\[240px\\] {
    height: 240px;
  }
  .h-\\[260px\\] {
    height: 260px;
  }
  .h-\\[300px\\] {
    height: 300px;
  }
  .h-\\[430px\\] {
    height: 430px;
  }
  .h-\\[fit-content\\] {
    height: fit-content;
  }
  .h-\\[var\\(--radix-select-trigger-height\\)\\] {
    height: var(--radix-select-trigger-height);
  }
  .h-auto {
    height: auto;
  }
  .h-fit {
    height: fit-content;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .max-h-32 {
    max-height: calc(var(--spacing) * 32);
  }
  .max-h-56 {
    max-height: calc(var(--spacing) * 56);
  }
  .max-h-\\[300px\\] {
    max-height: 300px;
  }
  .min-h-\\[60px\\] {
    min-height: 60px;
  }
  .min-h-\\[66px\\] {
    min-height: 66px;
  }
  .min-h-\\[100dvh\\] {
    min-height: 100dvh;
  }
  .min-h-\\[100px\\] {
    min-height: 100px;
  }
  .min-h-\\[100vh\\] {
    min-height: 100vh;
  }
  .min-h-\\[135px\\] {
    min-height: 135px;
  }
  .min-h-\\[150px\\] {
    min-height: 150px;
  }
  .min-h-\\[157px\\] {
    min-height: 157px;
  }
  .min-h-\\[160px\\] {
    min-height: 160px;
  }
  .min-h-\\[184px\\] {
    min-height: 184px;
  }
  .min-h-\\[196px\\] {
    min-height: 196px;
  }
  .min-h-\\[218px\\] {
    min-height: 218px;
  }
  .min-h-\\[235px\\] {
    min-height: 235px;
  }
  .min-h-\\[361px\\] {
    min-height: 361px;
  }
  .min-h-\\[inherit\\] {
    min-height: inherit;
  }
  .min-h-dvh {
    min-height: 100dvh;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .min-h-svh {
    min-height: 100svh;
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\.5 {
    width: calc(var(--spacing) * 2.5);
  }
  .w-2\\/3 {
    width: calc(2/3 * 100%);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-4\\/5 {
    width: calc(4/5 * 100%);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-11 {
    width: calc(var(--spacing) * 11);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-\\[30\\%\\] {
    width: 30%;
  }
  .w-\\[40\\%\\] {
    width: 40%;
  }
  .w-\\[60px\\] {
    width: 60px;
  }
  .w-\\[87px\\] {
    width: 87px;
  }
  .w-\\[88px\\] {
    width: 88px;
  }
  .w-\\[95\\%\\] {
    width: 95%;
  }
  .w-\\[100\\%\\] {
    width: 100%;
  }
  .w-\\[100px\\] {
    width: 100px;
  }
  .w-\\[100vw\\] {
    width: 100vw;
  }
  .w-auto {
    width: auto;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-screen {
    width: 100vw;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-45 {
    max-width: calc(var(--spacing) * 45);
  }
  .max-w-\\[60px\\] {
    max-width: 60px;
  }
  .max-w-\\[80\\%\\] {
    max-width: 80%;
  }
  .max-w-\\[600px\\] {
    max-width: 600px;
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .min-w-\\[60px\\] {
    min-width: 60px;
  }
  .min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
    min-width: var(--radix-select-trigger-width);
  }
  .flex-1 {
    flex: 1;
  }
  .flex-none {
    flex: none;
  }
  .flex-shrink {
    flex-shrink: 1;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .grow {
    flex-grow: 1;
  }
  .caption-bottom {
    caption-side: bottom;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .-translate-x-1 {
    --tw-translate-x: calc(var(--spacing) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-\\[-50\\%\\] {
    --tw-translate-x: -50%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1 {
    --tw-translate-y: calc(var(--spacing) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-1 {
    --tw-translate-y: calc(var(--spacing) * 1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-1\\/2 {
    --tw-translate-y: calc(1/2 * 100%);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-\\[-50\\%\\] {
    --tw-translate-y: -50%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .touch-pinch-zoom {
    --tw-pinch-zoom: pinch-zoom;
    touch-action: var(--tw-pan-x,) var(--tw-pan-y,) var(--tw-pinch-zoom,);
  }
  .touch-none {
    touch-action: none;
  }
  .resize {
    resize: both;
  }
  .resize-none {
    resize: none;
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-around {
    justify-content: space-around;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .gap-0 {
    gap: calc(var(--spacing) * 0);
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-\\[2px\\] {
    gap: 2px;
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-reverse {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 1;
    }
  }
  .space-x-1 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 1) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-4 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-reverse {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 1;
    }
  }
  .divide-x {
    :where(& > :not(:last-child)) {
      --tw-divide-x-reverse: 0;
      border-inline-style: var(--tw-border-style);
      border-inline-start-width: calc(1px * var(--tw-divide-x-reverse));
      border-inline-end-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
    }
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-y-reverse {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 1;
    }
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-x-scroll {
    overflow-x: scroll;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-\\[4px\\] {
    border-radius: 4px;
  }
  .rounded-\\[10px\\] {
    border-radius: 10px;
  }
  .rounded-\\[inherit\\] {
    border-radius: inherit;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-s {
    border-start-start-radius: 0.25rem;
    border-end-start-radius: 0.25rem;
  }
  .rounded-ss {
    border-start-start-radius: 0.25rem;
  }
  .rounded-e {
    border-start-end-radius: 0.25rem;
    border-end-end-radius: 0.25rem;
  }
  .rounded-se {
    border-start-end-radius: 0.25rem;
  }
  .rounded-ee {
    border-end-end-radius: 0.25rem;
  }
  .rounded-es {
    border-end-start-radius: 0.25rem;
  }
  .rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  .rounded-t-2xl {
    border-top-left-radius: var(--radius-2xl);
    border-top-right-radius: var(--radius-2xl);
  }
  .rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .rounded-l-full {
    border-top-left-radius: calc(infinity * 1px);
    border-bottom-left-radius: calc(infinity * 1px);
  }
  .rounded-tl {
    border-top-left-radius: 0.25rem;
  }
  .rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
  .rounded-tr {
    border-top-right-radius: 0.25rem;
  }
  .rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .rounded-b-2xl {
    border-bottom-right-radius: var(--radius-2xl);
    border-bottom-left-radius: var(--radius-2xl);
  }
  .rounded-br {
    border-bottom-right-radius: 0.25rem;
  }
  .rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-\\[1px\\] {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-x {
    border-inline-style: var(--tw-border-style);
    border-inline-width: 1px;
  }
  .border-y {
    border-block-style: var(--tw-border-style);
    border-block-width: 1px;
  }
  .border-s {
    border-inline-start-style: var(--tw-border-style);
    border-inline-start-width: 1px;
  }
  .border-e {
    border-inline-end-style: var(--tw-border-style);
    border-inline-end-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-\\[var\\(--macaroniAndCheese\\)\\] {
    border-color: var(--macaroniAndCheese);
  }
  .border-card-secondary {
    border-color: var(--color-card-secondary);
  }
  .border-input {
    border-color: var(--color-input);
  }
  .border-primary {
    border-color: var(--color-primary);
  }
  .border-purple-200 {
    border-color: var(--color-purple-200);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-t-transparent {
    border-top-color: transparent;
  }
  .border-l-transparent {
    border-left-color: transparent;
  }
  .bg-\\[\\#6E6A6E\\] {
    background-color: #6E6A6E;
  }
  .bg-\\[\\#212121\\] {
    background-color: #212121;
  }
  .bg-\\[\\#DEDEDE\\] {
    background-color: #DEDEDE;
  }
  .bg-\\[var\\(--backgroundCard\\)\\] {
    background-color: var(--backgroundCard);
  }
  .bg-\\[var\\(--backgroundDatePicker\\)\\] {
    background-color: var(--backgroundDatePicker);
  }
  .bg-\\[var\\(--backgroundHeader\\)\\] {
    background-color: var(--backgroundHeader);
  }
  .bg-\\[var\\(--backgroundInvert\\)\\] {
    background-color: var(--backgroundInvert);
  }
  .bg-\\[var\\(--backgroundSecondary\\)\\] {
    background-color: var(--backgroundSecondary);
  }
  .bg-\\[var\\(--macaroniAndCheese-60\\)\\] {
    background-color: var(--macaroniAndCheese-60);
  }
  .bg-\\[var\\(--tab\\)\\] {
    background-color: var(--tab);
  }
  .bg-\\[var\\(--tabActive\\)\\] {
    background-color: var(--tabActive);
  }
  .bg-background {
    background-color: var(--color-background);
  }
  .bg-background-button {
    background-color: var(--color-background-button);
  }
  .bg-background-button-date {
    background-color: var(--color-background-button-date);
  }
  .bg-background-card {
    background-color: var(--color-background-card);
  }
  .bg-background-date-picker {
    background-color: var(--color-background-date-picker);
  }
  .bg-background-invert {
    background-color: var(--color-background-invert);
  }
  .bg-background-secondary {
    background-color: var(--color-background-secondary);
  }
  .bg-background-select {
    background-color: var(--color-background-select);
  }
  .bg-black {
    background-color: var(--color-black);
  }
  .bg-black\\/20 {
    background-color: color-mix(in srgb, #000 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 20%, transparent);
    }
  }
  .bg-black\\/80 {
    background-color: color-mix(in srgb, #000 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 80%, transparent);
    }
  }
  .bg-border {
    background-color: var(--color-border);
  }
  .bg-card {
    background-color: var(--color-card);
  }
  .bg-destructive {
    background-color: var(--color-destructive);
  }
  .bg-foreground {
    background-color: var(--color-foreground);
  }
  .bg-gray-300 {
    background-color: var(--color-gray-300);
  }
  .bg-gray-500 {
    background-color: var(--color-gray-500);
  }
  .bg-gray-600 {
    background-color: var(--color-gray-600);
  }
  .bg-green-500 {
    background-color: var(--color-green-500);
  }
  .bg-muted {
    background-color: var(--color-muted);
  }
  .bg-muted\\/50 {
    background-color: color-mix(in srgb, hsl(var(--muted)) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 50%, transparent);
    }
  }
  .bg-pink-500 {
    background-color: var(--color-pink-500);
  }
  .bg-pink-500\\/80 {
    background-color: color-mix(in srgb, oklch(65.6% 0.241 354.308) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-pink-500) 80%, transparent);
    }
  }
  .bg-popover {
    background-color: var(--color-popover);
  }
  .bg-primary {
    background-color: var(--color-primary);
  }
  .bg-purple-700 {
    background-color: var(--color-purple-700);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-secondary {
    background-color: var(--color-secondary);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-linear-to-r {
    --tw-gradient-position: to right;
    @supports (background-image: linear-gradient(in lab, red, red)) {
      --tw-gradient-position: to right in oklab;
    }
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-\\[linear-gradient\\(180deg\\,_\\#82B1FF_0\\%\\,_\\#6f7aff_100\\%\\)\\] {
    background-image: linear-gradient(180deg, #82B1FF 0%, #6f7aff 100%);
  }
  .bg-\\[linear-gradient\\(180deg\\,_rgba\\(111\\,122\\,255\\,0\\.6166841736694677\\)_100\\%\\,_\\#665FFF_100\\%\\)\\] {
    background-image: linear-gradient(180deg, rgba(111,122,255,0.6166841736694677) 100%, #665FFF 100%);
  }
  .from-gray-800 {
    --tw-gradient-from: var(--color-gray-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-gray-900 {
    --tw-gradient-to: var(--color-gray-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .bg-cover {
    background-size: cover;
  }
  .bg-center {
    background-position: center;
  }
  .bg-repeat {
    background-repeat: repeat;
  }
  .fill-primary {
    fill: var(--color-primary);
  }
  .object-cover {
    object-fit: cover;
  }
  .object-bottom-left {
    object-position: left bottom;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .p-\\[1px\\] {
    padding: 1px;
  }
  .p-\\[13px\\] {
    padding: 13px;
  }
  .px-0 {
    padding-inline: calc(var(--spacing) * 0);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .px-\\[4px\\] {
    padding-inline: 4px;
  }
  .py-0 {
    padding-block: calc(var(--spacing) * 0);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .py-\\[2px\\] {
    padding-block: 2px;
  }
  .py-\\[4px\\] {
    padding-block: 4px;
  }
  .py-\\[9px\\] {
    padding-block: 9px;
  }
  .pt-0 {
    padding-top: calc(var(--spacing) * 0);
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pt-9 {
    padding-top: calc(var(--spacing) * 9);
  }
  .pt-11 {
    padding-top: calc(var(--spacing) * 11);
  }
  .pt-14 {
    padding-top: calc(var(--spacing) * 14);
  }
  .pt-20 {
    padding-top: calc(var(--spacing) * 20);
  }
  .pt-\\[2px\\] {
    padding-top: 2px;
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-2\\.5 {
    padding-right: calc(var(--spacing) * 2.5);
  }
  .pr-4 {
    padding-right: calc(var(--spacing) * 4);
  }
  .pr-8 {
    padding-right: calc(var(--spacing) * 8);
  }
  .pb-0 {
    padding-bottom: calc(var(--spacing) * 0);
  }
  .pb-0\\.5 {
    padding-bottom: calc(var(--spacing) * 0.5);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-5 {
    padding-bottom: calc(var(--spacing) * 5);
  }
  .pb-8 {
    padding-bottom: calc(var(--spacing) * 8);
  }
  .pb-16 {
    padding-bottom: calc(var(--spacing) * 16);
  }
  .pb-28 {
    padding-bottom: calc(var(--spacing) * 28);
  }
  .pb-32 {
    padding-bottom: calc(var(--spacing) * 32);
  }
  .pb-\\[6px\\] {
    padding-bottom: 6px;
  }
  .pb-\\[102px\\] {
    padding-bottom: 102px;
  }
  .pb-\\[113px\\] {
    padding-bottom: 113px;
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-2\\.5 {
    padding-left: calc(var(--spacing) * 2.5);
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8);
  }
  .pl-\\[14px\\] {
    padding-left: 14px;
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .align-middle {
    vertical-align: middle;
  }
  .font-press-start {
    font-family: var(--font-press-start);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[0\\.8rem\\] {
    font-size: 0.8rem;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[14px\\] {
    font-size: 14px;
  }
  .text-\\[20px\\] {
    font-size: 20px;
  }
  .text-\\[22px\\] {
    font-size: 22px;
  }
  .text-\\[29px\\] {
    font-size: 29px;
  }
  .text-\\[32px\\] {
    font-size: 32px;
  }
  .leading-\\[100\\%\\] {
    --tw-leading: 100%;
    line-height: 100%;
  }
  .leading-\\[115\\%\\] {
    --tw-leading: 115%;
    line-height: 115%;
  }
  .leading-\\[122\\%\\] {
    --tw-leading: 122%;
    line-height: 122%;
  }
  .leading-\\[140\\%\\] {
    --tw-leading: 140%;
    line-height: 140%;
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest);
    letter-spacing: var(--tracking-widest);
  }
  .text-nowrap {
    text-wrap: nowrap;
  }
  .text-wrap {
    text-wrap: wrap;
  }
  .text-clip {
    text-overflow: clip;
  }
  .text-ellipsis {
    text-overflow: ellipsis;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .text-blue-400 {
    color: var(--color-blue-400);
  }
  .text-card-foreground {
    color: var(--color-card-foreground);
  }
  .text-destructive {
    color: var(--color-destructive);
  }
  .text-destructive-foreground {
    color: var(--color-destructive-foreground);
  }
  .text-foreground {
    color: var(--color-foreground);
  }
  .text-gray-300 {
    color: var(--color-gray-300);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-green-700 {
    color: var(--color-green-700);
  }
  .text-muted-foreground {
    color: var(--color-muted-foreground);
  }
  .text-orange-300 {
    color: var(--color-orange-300);
  }
  .text-popover-foreground {
    color: var(--color-popover-foreground);
  }
  .text-primary {
    color: var(--color-primary);
  }
  .text-primary-foreground {
    color: var(--color-primary-foreground);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-secondary-foreground {
    color: var(--color-secondary-foreground);
  }
  .text-text-invert {
    color: var(--color-text-invert);
  }
  .text-text-placeholder {
    color: var(--color-text-placeholder);
  }
  .text-text-primary {
    color: var(--color-text-primary);
  }
  .text-text-secondary {
    color: var(--color-text-secondary);
  }
  .text-text-third {
    color: var(--color-text-third);
  }
  .text-white {
    color: var(--color-white);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .normal-case {
    text-transform: none;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .not-italic {
    font-style: normal;
  }
  .diagonal-fractions {
    --tw-numeric-fraction: diagonal-fractions;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .lining-nums {
    --tw-numeric-figure: lining-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .oldstyle-nums {
    --tw-numeric-figure: oldstyle-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .ordinal {
    --tw-ordinal: ordinal;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .proportional-nums {
    --tw-numeric-spacing: proportional-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .slashed-zero {
    --tw-slashed-zero: slashed-zero;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .stacked-fractions {
    --tw-numeric-fraction: stacked-fractions;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .normal-nums {
    font-variant-numeric: normal;
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .no-underline {
    text-decoration-line: none;
  }
  .overline {
    text-decoration-line: overline;
  }
  .underline {
    text-decoration-line: underline;
  }
  .underline-offset-4 {
    text-underline-offset: 4px;
  }
  .antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-90 {
    opacity: 90%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-none {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xs {
    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-offset-background {
    --tw-ring-offset-color: var(--color-background);
  }
  .outline-hidden {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .brightness-50 {
    --tw-brightness: brightness(50%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow {
    --tw-drop-shadow-size: drop-shadow(0 1px 2px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.1))) drop-shadow(0 1px 1px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.06)));
    --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow( 0 1px 1px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .grayscale {
    --tw-grayscale: grayscale(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .sepia {
    --tw-sepia: sepia(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur {
    --tw-backdrop-blur: blur(8px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-grayscale {
    --tw-backdrop-grayscale: grayscale(100%);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-invert {
    --tw-backdrop-invert: invert(100%);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-sepia {
    --tw-backdrop-sepia: sepia(100%);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-filter {
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .backface-hidden {
    backface-visibility: hidden;
  }
  .divide-x-reverse {
    :where(& > :not(:last-child)) {
      --tw-divide-x-reverse: 1;
    }
  }
  .duration-150 {
    animation-duration: 150ms;
  }
  .duration-200 {
    animation-duration: 200ms;
  }
  .duration-300 {
    animation-duration: 300ms;
  }
  .ease-in-out {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  .ease-out {
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  .paused {
    animation-play-state: paused;
  }
  .ring-inset {
    --tw-ring-inset: inset;
  }
  .running {
    animation-play-state: running;
  }
  .zoom-in {
    --tw-enter-scale: 0;
  }
  .zoom-out {
    --tw-exit-scale: 0;
  }
  .peer-disabled\\:cursor-not-allowed {
    &:is(:where(.peer):disabled ~ *) {
      cursor: not-allowed;
    }
  }
  .peer-disabled\\:opacity-70 {
    &:is(:where(.peer):disabled ~ *) {
      opacity: 70%;
    }
  }
  .file\\:border-0 {
    &::file-selector-button {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .file\\:bg-transparent {
    &::file-selector-button {
      background-color: transparent;
    }
  }
  .placeholder\\:text-sm {
    &::placeholder {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
  }
  .placeholder\\:text-xl {
    &::placeholder {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  .placeholder\\:text-\\[14px\\] {
    &::placeholder {
      font-size: 14px;
    }
  }
  .placeholder\\:font-bold {
    &::placeholder {
      --tw-font-weight: var(--font-weight-bold);
      font-weight: var(--font-weight-bold);
    }
  }
  .placeholder\\:text-text-invert {
    &::placeholder {
      color: var(--color-text-invert);
    }
  }
  .placeholder\\:text-text-placeholder {
    &::placeholder {
      color: var(--color-text-placeholder);
    }
  }
  .placeholder\\:text-text-secondary {
    &::placeholder {
      color: var(--color-text-secondary);
    }
  }
  .placeholder\\:text-text-third {
    &::placeholder {
      color: var(--color-text-third);
    }
  }
  .placeholder\\:uppercase {
    &::placeholder {
      text-transform: uppercase;
    }
  }
  .before\\:absolute {
    &::before {
      content: var(--tw-content);
      position: absolute;
    }
  }
  .before\\:top-1\\/2 {
    &::before {
      content: var(--tw-content);
      top: calc(1/2 * 100%);
    }
  }
  .before\\:left-1\\/2 {
    &::before {
      content: var(--tw-content);
      left: calc(1/2 * 100%);
    }
  }
  .before\\:h-full {
    &::before {
      content: var(--tw-content);
      height: 100%;
    }
  }
  .before\\:min-h-\\[44px\\] {
    &::before {
      content: var(--tw-content);
      min-height: 44px;
    }
  }
  .before\\:w-full {
    &::before {
      content: var(--tw-content);
      width: 100%;
    }
  }
  .before\\:min-w-\\[44px\\] {
    &::before {
      content: var(--tw-content);
      min-width: 44px;
    }
  }
  .before\\:-translate-x-1\\/2 {
    &::before {
      content: var(--tw-content);
      --tw-translate-x: calc(calc(1/2 * 100%) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .before\\:-translate-y-1\\/2 {
    &::before {
      content: var(--tw-content);
      --tw-translate-y: calc(calc(1/2 * 100%) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .before\\:content-\\[\\'\\'\\] {
    &::before {
      content: var(--tw-content);
      --tw-content: '';
      content: var(--tw-content);
    }
  }
  .after\\:pointer-events-none {
    &::after {
      content: var(--tw-content);
      pointer-events: none;
    }
  }
  .after\\:absolute {
    &::after {
      content: var(--tw-content);
      position: absolute;
    }
  }
  .after\\:bottom-0 {
    &::after {
      content: var(--tw-content);
      bottom: calc(var(--spacing) * 0);
    }
  }
  .after\\:left-0 {
    &::after {
      content: var(--tw-content);
      left: calc(var(--spacing) * 0);
    }
  }
  .after\\:hidden {
    &::after {
      content: var(--tw-content);
      display: none;
    }
  }
  .after\\:h-32 {
    &::after {
      content: var(--tw-content);
      height: calc(var(--spacing) * 32);
    }
  }
  .after\\:w-full {
    &::after {
      content: var(--tw-content);
      width: 100%;
    }
  }
  .after\\:bg-\\[linear-gradient\\(180deg\\,_transparent_10\\%\\,_hsl\\(var\\(--background\\)\\)_70\\%\\)\\] {
    &::after {
      content: var(--tw-content);
      background-image: linear-gradient(180deg, transparent 10%, hsl(var(--background)) 70%);
    }
  }
  .focus-within\\:relative {
    &:focus-within {
      position: relative;
    }
  }
  .focus-within\\:z-20 {
    &:focus-within {
      z-index: 20;
    }
  }
  .hover\\:scale-105 {
    &:hover {
      @media (hover: hover) {
        --tw-scale-x: 105%;
        --tw-scale-y: 105%;
        --tw-scale-z: 105%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .hover\\:bg-\\[\\#5D5A5D\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #5D5A5D;
      }
    }
  }
  .hover\\:bg-accent {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-accent);
      }
    }
  }
  .hover\\:bg-background-button {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-background-button);
      }
    }
  }
  .hover\\:bg-background-card {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-background-card);
      }
    }
  }
  .hover\\:bg-background-invert {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-background-invert);
      }
    }
  }
  .hover\\:bg-background-select {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-background-select);
      }
    }
  }
  .hover\\:bg-destructive\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--destructive)) 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-destructive) 80%, transparent);
        }
      }
    }
  }
  .hover\\:bg-destructive\\/90 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--destructive)) 90%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-destructive) 90%, transparent);
        }
      }
    }
  }
  .hover\\:bg-gray-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-700);
      }
    }
  }
  .hover\\:bg-gray-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-800);
      }
    }
  }
  .hover\\:bg-muted {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-muted);
      }
    }
  }
  .hover\\:bg-muted\\/50 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--muted)) 50%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-muted) 50%, transparent);
        }
      }
    }
  }
  .hover\\:bg-pink-500\\/70 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(65.6% 0.241 354.308) 70%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-pink-500) 70%, transparent);
        }
      }
    }
  }
  .hover\\:bg-primary\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--primary)) 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-primary) 80%, transparent);
        }
      }
    }
  }
  .hover\\:bg-red-600 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-red-600);
      }
    }
  }
  .hover\\:bg-secondary\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--secondary)) 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-secondary) 80%, transparent);
        }
      }
    }
  }
  .hover\\:text-accent-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--color-accent-foreground);
      }
    }
  }
  .hover\\:text-primary-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-foreground);
      }
    }
  }
  .hover\\:text-text-invert {
    &:hover {
      @media (hover: hover) {
        color: var(--color-text-invert);
      }
    }
  }
  .hover\\:text-text-third {
    &:hover {
      @media (hover: hover) {
        color: var(--color-text-third);
      }
    }
  }
  .hover\\:text-white {
    &:hover {
      @media (hover: hover) {
        color: var(--color-white);
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:opacity-80 {
    &:hover {
      @media (hover: hover) {
        opacity: 80%;
      }
    }
  }
  .hover\\:opacity-100 {
    &:hover {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .hover\\:shadow-xl {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .focus\\:bg-background-button {
    &:focus {
      background-color: var(--color-background-button);
    }
  }
  .focus\\:bg-background-select {
    &:focus {
      background-color: var(--color-background-select);
    }
  }
  .focus\\:text-primary-foreground {
    &:focus {
      color: var(--color-primary-foreground);
    }
  }
  .focus\\:text-text-invert {
    &:focus {
      color: var(--color-text-invert);
    }
  }
  .focus\\:shadow-none {
    &:focus {
      --tw-shadow: 0 0 #0000;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-red-400 {
    &:focus {
      --tw-ring-color: var(--color-red-400);
    }
  }
  .focus\\:ring-ring {
    &:focus {
      --tw-ring-color: var(--color-ring);
    }
  }
  .focus\\:ring-offset-2 {
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus\\:outline-hidden {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    }
  }
  .focus-visible\\:ring-1 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-2 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-ring {
    &:focus-visible {
      --tw-ring-color: var(--color-ring);
    }
  }
  .focus-visible\\:ring-offset-2 {
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus-visible\\:ring-offset-background {
    &:focus-visible {
      --tw-ring-offset-color: var(--color-background);
    }
  }
  .focus-visible\\:outline-hidden {
    &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    }
  }
  .disabled\\:pointer-events-none {
    &:disabled {
      pointer-events: none;
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:opacity-20 {
    &:disabled {
      opacity: 20%;
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50%;
    }
  }
  .aria-selected\\:bg-accent\\/50 {
    &[aria-selected="true"] {
      background-color: color-mix(in srgb, hsl(var(--accent)) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-accent) 50%, transparent);
      }
    }
  }
  .aria-selected\\:bg-background-button {
    &[aria-selected="true"] {
      background-color: var(--color-background-button);
    }
  }
  .aria-selected\\:text-accent-foreground {
    &[aria-selected="true"] {
      color: var(--color-accent-foreground);
    }
  }
  .aria-selected\\:text-muted-foreground {
    &[aria-selected="true"] {
      color: var(--color-muted-foreground);
    }
  }
  .aria-selected\\:opacity-100 {
    &[aria-selected="true"] {
      opacity: 100%;
    }
  }
  .data-disabled\\:pointer-events-none {
    &[data-disabled] {
      pointer-events: none;
    }
  }
  .data-disabled\\:opacity-50 {
    &[data-disabled] {
      opacity: 50%;
    }
  }
  .data-\\[disabled\\=true\\]\\:pointer-events-none {
    &[data-disabled="true"] {
      pointer-events: none;
    }
  }
  .data-\\[disabled\\=true\\]\\:opacity-50 {
    &[data-disabled="true"] {
      opacity: 50%;
    }
  }
  .data-\\[orientation\\=horizontal\\]\\:h-2\\.5 {
    &[data-orientation="horizontal"] {
      height: calc(var(--spacing) * 2.5);
    }
  }
  .data-\\[orientation\\=horizontal\\]\\:flex-col {
    &[data-orientation="horizontal"] {
      flex-direction: column;
    }
  }
  .data-\\[orientation\\=vertical\\]\\:w-2\\.5 {
    &[data-orientation="vertical"] {
      width: calc(var(--spacing) * 2.5);
    }
  }
  .data-\\[side\\=bottom\\]\\:translate-y-1 {
    &[data-side="bottom"] {
      --tw-translate-y: calc(var(--spacing) * 1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=bottom\\]\\:slide-in-from-top-2 {
    &[data-side="bottom"] {
      --tw-enter-translate-y: -0.5rem;
    }
  }
  .data-\\[side\\=left\\]\\:-translate-x-1 {
    &[data-side="left"] {
      --tw-translate-x: calc(var(--spacing) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=left\\]\\:slide-in-from-right-2 {
    &[data-side="left"] {
      --tw-enter-translate-x: 0.5rem;
    }
  }
  .data-\\[side\\=right\\]\\:translate-x-1 {
    &[data-side="right"] {
      --tw-translate-x: calc(var(--spacing) * 1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=right\\]\\:slide-in-from-left-2 {
    &[data-side="right"] {
      --tw-enter-translate-x: -0.5rem;
    }
  }
  .data-\\[side\\=top\\]\\:-translate-y-1 {
    &[data-side="top"] {
      --tw-translate-y: calc(var(--spacing) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=top\\]\\:rounded-2xl {
    &[data-side="top"] {
      border-radius: var(--radius-2xl);
    }
  }
  .data-\\[side\\=top\\]\\:slide-in-from-bottom-2 {
    &[data-side="top"] {
      --tw-enter-translate-y: 0.5rem;
    }
  }
  .data-\\[state\\=active\\]\\:bg-background-button {
    &[data-state="active"] {
      background-color: var(--color-background-button);
    }
  }
  .data-\\[state\\=active\\]\\:text-text-invert {
    &[data-state="active"] {
      color: var(--color-text-invert);
    }
  }
  .data-\\[state\\=active\\]\\:shadow-sm {
    &[data-state="active"] {
      --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .data-\\[state\\=checked\\]\\:translate-x-4 {
    &[data-state="checked"] {
      --tw-translate-x: calc(var(--spacing) * 4);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[state\\=checked\\]\\:bg-green-500 {
    &[data-state="checked"] {
      background-color: var(--color-green-500);
    }
  }
  .data-\\[state\\=checked\\]\\:bg-primary {
    &[data-state="checked"] {
      background-color: var(--color-primary);
    }
  }
  .data-\\[state\\=closed\\]\\:scale-95 {
    &[data-state="closed"] {
      --tw-scale-x: 95%;
      --tw-scale-y: 95%;
      --tw-scale-z: 95%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .data-\\[state\\=closed\\]\\:animate-out {
    &[data-state="closed"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[state\\=closed\\]\\:fade-out-0 {
    &[data-state="closed"] {
      --tw-exit-opacity: 0;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2 {
    &[data-state="closed"] {
      --tw-exit-translate-x: -50%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\] {
    &[data-state="closed"] {
      --tw-exit-translate-y: -48%;
    }
  }
  .data-\\[state\\=closed\\]\\:zoom-out-95 {
    &[data-state="closed"] {
      --tw-exit-scale: .95;
    }
  }
  .data-\\[state\\=open\\]\\:scale-100 {
    &[data-state="open"] {
      --tw-scale-x: 100%;
      --tw-scale-y: 100%;
      --tw-scale-z: 100%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .data-\\[state\\=open\\]\\:bg-accent {
    &[data-state="open"] {
      background-color: var(--color-accent);
    }
  }
  .data-\\[state\\=open\\]\\:text-muted-foreground {
    &[data-state="open"] {
      color: var(--color-muted-foreground);
    }
  }
  .data-\\[state\\=open\\]\\:animate-in {
    &[data-state="open"] {
      animation-name: enter;
      animation-duration: 150ms;
      --tw-enter-opacity: initial;
      --tw-enter-scale: initial;
      --tw-enter-rotate: initial;
      --tw-enter-translate-x: initial;
      --tw-enter-translate-y: initial;
    }
  }
  .data-\\[state\\=open\\]\\:fade-in-0 {
    &[data-state="open"] {
      --tw-enter-opacity: 0;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2 {
    &[data-state="open"] {
      --tw-enter-translate-x: -50%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\] {
    &[data-state="open"] {
      --tw-enter-translate-y: -48%;
    }
  }
  .data-\\[state\\=open\\]\\:zoom-in-95 {
    &[data-state="open"] {
      --tw-enter-scale: .95;
    }
  }
  .data-\\[state\\=selected\\]\\:bg-muted {
    &[data-state="selected"] {
      background-color: var(--color-muted);
    }
  }
  .data-\\[state\\=unchecked\\]\\:translate-x-0 {
    &[data-state="unchecked"] {
      --tw-translate-x: calc(var(--spacing) * 0);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[state\\=unchecked\\]\\:bg-gray-400 {
    &[data-state="unchecked"] {
      background-color: var(--color-gray-400);
    }
  }
  .data-\\[state\\=unchecked\\]\\:bg-input {
    &[data-state="unchecked"] {
      background-color: var(--color-input);
    }
  }
  .sm\\:mt-0 {
    @media (width >= 40rem) {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:justify-end {
    @media (width >= 40rem) {
      justify-content: flex-end;
    }
  }
  .sm\\:space-x-2 {
    @media (width >= 40rem) {
      :where(& > :not(:last-child)) {
        --tw-space-x-reverse: 0;
        margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
        margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
      }
    }
  }
  .sm\\:rounded-lg {
    @media (width >= 40rem) {
      border-radius: var(--radius-lg);
    }
  }
  .sm\\:text-left {
    @media (width >= 40rem) {
      text-align: left;
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 {
    & [cmdk-group-heading] {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 {
    & [cmdk-group-heading] {
      padding-block: calc(var(--spacing) * 1.5);
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs {
    & [cmdk-group-heading] {
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium {
    & [cmdk-group-heading] {
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground {
    & [cmdk-group-heading] {
      color: var(--color-muted-foreground);
    }
  }
  .\\[\\&_\\[cmdk-group\\]\\]\\:px-2 {
    & [cmdk-group] {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  .\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 {
    & [cmdk-group]:not([hidden]) ~[cmdk-group] {
      padding-top: calc(var(--spacing) * 0);
    }
  }
  .\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 {
    & [cmdk-input-wrapper] svg {
      height: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 {
    & [cmdk-input-wrapper] svg {
      width: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_\\[cmdk-input\\]\\]\\:h-12 {
    & [cmdk-input] {
      height: calc(var(--spacing) * 12);
    }
  }
  .\\[\\&_\\[cmdk-item\\]\\]\\:px-2 {
    & [cmdk-item] {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  .\\[\\&_\\[cmdk-item\\]\\]\\:py-3 {
    & [cmdk-item] {
      padding-block: calc(var(--spacing) * 3);
    }
  }
  .\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 {
    & [cmdk-item] svg {
      height: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 {
    & [cmdk-item] svg {
      width: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_svg\\]\\:pointer-events-none {
    & svg {
      pointer-events: none;
    }
  }
  .\\[\\&_svg\\]\\:size-4 {
    & svg {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
  }
  .\\[\\&_svg\\]\\:shrink-0 {
    & svg {
      flex-shrink: 0;
    }
  }
  .\\[\\&_tr\\]\\:border-b {
    & tr {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
    }
  }
  .\\[\\&_tr\\:last-child\\]\\:border-0 {
    & tr:last-child {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md {
    &:has(>.day-range-end) {
      border-top-right-radius: var(--radius-md);
      border-bottom-right-radius: var(--radius-md);
    }
  }
  .\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-lg {
    &:has(>.day-range-start) {
      border-top-left-radius: var(--radius-lg);
      border-bottom-left-radius: var(--radius-lg);
    }
  }
  .\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-lg {
    &:has([aria-selected]) {
      border-radius: var(--radius-lg);
    }
  }
  .\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent {
    &:has([aria-selected]) {
      background-color: var(--color-accent);
    }
  }
  .first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-lg {
    &:first-child {
      &:has([aria-selected]) {
        border-top-left-radius: var(--radius-lg);
        border-bottom-left-radius: var(--radius-lg);
      }
    }
  }
  .last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-lg {
    &:last-child {
      &:has([aria-selected]) {
        border-top-right-radius: var(--radius-lg);
        border-bottom-right-radius: var(--radius-lg);
      }
    }
  }
  .\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50 {
    &:has([aria-selected].day-outside) {
      background-color: color-mix(in srgb, hsl(var(--accent)) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-accent) 50%, transparent);
      }
    }
  }
  .\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-lg {
    &:has([aria-selected].day-range-end) {
      border-top-right-radius: var(--radius-lg);
      border-bottom-right-radius: var(--radius-lg);
    }
  }
  .\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0 {
    &:has([role=checkbox]) {
      padding-right: calc(var(--spacing) * 0);
    }
  }
  .\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\] {
    &>[role=checkbox] {
      --tw-translate-y: 2px;
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .\\[\\&\\>span\\]\\:line-clamp-1 {
    &>span {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
  }
  .last\\:\\[\\&\\>tr\\]\\:border-b-0 {
    &:last-child {
      &>tr {
        border-bottom-style: var(--tw-border-style);
        border-bottom-width: 0px;
      }
    }
  }
  .\\[\\@closed\\]\\:-translate-x-\\[50\\%\\] {
    @closed {
      --tw-translate-x: calc(50% * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .\\[\\@closed\\]\\:-translate-y-\\[48\\%\\] {
    @closed {
      --tw-translate-y: calc(48% * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .\\[\\@closed\\]\\:scale-95 {
    @closed {
      --tw-scale-x: 95%;
      --tw-scale-y: 95%;
      --tw-scale-z: 95%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .\\[\\@closed\\]\\:animate-out {
    @closed {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .\\[\\@closed\\]\\:fade-out-0 {
    @closed {
      --tw-exit-opacity: 0;
    }
  }
  .\\[\\@open\\]\\:translate-x-\\[50\\%\\] {
    @open {
      --tw-translate-x: 50%;
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .\\[\\@open\\]\\:translate-y-\\[48\\%\\] {
    @open {
      --tw-translate-y: 48%;
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .\\[\\@open\\]\\:scale-100 {
    @open {
      --tw-scale-x: 100%;
      --tw-scale-y: 100%;
      --tw-scale-z: 100%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .\\[\\@open\\]\\:animate-in {
    @open {
      animation-name: enter;
      animation-duration: 150ms;
      --tw-enter-opacity: initial;
      --tw-enter-scale: initial;
      --tw-enter-rotate: initial;
      --tw-enter-translate-x: initial;
      --tw-enter-translate-y: initial;
    }
  }
  .\\[\\@open\\]\\:fade-in-0 {
    @open {
      --tw-enter-opacity: 0;
    }
  }
}
:root {
  --karry: 29, 100%, 92%;
  --matterhorn: 324, 13%, 23%;
  --persimmon: 7.326, 100%, 66%;
  --romantic: hsl(17.746, 100%, 86%);
  --romantic-00: hsla(16, 100%, 87%, 0);
  --salmon: hsl(16.107, 100%, 71%);
  --salmon-50: hsla(16, 100%, 71%, 0.5);
  --seashellPeach: hsl(26.667, 100%, 97%);
  --white: hsl(0, 0%, 100%);
  --macaroniAndCheese: hsl(28, 100%, 75%, 1);
  --macaroniAndCheese-60: hsla(28, 100%, 75%, 0.6);
}
.background-gradient {
  background: linear-gradient(to bottom, var(--seashellPeach), var(--romantic));
}
.background-gradient-second {
  background: linear-gradient( to bottom, hsl(var(--karry)), var(--seashellPeach) );
}
.background-gradient-articles {
  background: linear-gradient(to right, #fff5ed, #fff7f1cc);
}
.background-gradient-page {
  background: linear-gradient(to bottom, var(--white), var(--white));
}
.background-gradient-event {
  background: linear-gradient( to bottom, hsla(var(--matterhorn), 0.08), hsla(var(--matterhorn), 1) );
}
.background-gradient-you {
  background: linear-gradient(to bottom, var(--romantic-00), var(--salmon-50));
}
.box-shadow-articles {
  box-shadow: 0 0 30px 0 hsla(7, 100%, 66%, 0.23);
}
.box-shadow-form {
  box-shadow: 0 8px 30px 0 hsla(7, 100%, 66%, 0.23);
}
.background-blur {
  backdrop-filter: blur(20px);
}
.clip-path {
  position: relative;
  margin-left: -2px;
  margin-right: -2px;
  width: 64px;
  height: 80px;
  background-color: var(--white);
  clip-path: path("M 0 84 L 0 12 A 32 32 0 0 0 64 12 L 64 88 Z");
}
@layer base {
  *,
  ::after,
  ::before,
  ::backdrop,
  ::file-selector-button {
    border-color: var(--color-gray-200, currentcolor);
  }
}
@layer base {
  :root {
    --header-height: 4rem;
    --tw-shadow-color: black;
    --background: 0 0% 100%;
    --backgroundButton: var(--persimmon);
    --backgroundButtonDate: var(--karry);
    --backgroundCard: var(--salmon);
    --backgroundDatePicker: var(--seashellPeach);
    --backgroundInvert: var(--white);
    --backgroundHeader: var(--white);
    --backgroundSecondary: var(--seashellPeach);
    --backgroundSelect: var(--macaroniAndCheese);
    --foreground: var(--matterhorn);
    --card: 0 0% 100%;
    --card-foreground: 0 0% 3.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 0 0% 3.9%;
    --primary: 0 0% 9%;
    --primary-foreground: 0 0% 98%;
    --secondary: 0 0% 96.1%;
    --secondary-foreground: 0 0% 9%;
    --tab: hsla(324, 13%, 23%, 0.6);
    --tabActive: hsla(15, 91%, 61%, 0.6);
    --tabActiveSecondary: hsla(28, 100%, 75%, 0.6);
    --textInvert: var(--white);
    --textPlaceholder: var(--macaroniAndCheese);
    --textPrimary: var(--matterhorn);
    --textSecondary: var(--persimmon);
    --textThird: var(--salmon);
    --pagination: hsl(var(--karry));
    --paginationActive: var(--macaroniAndCheese);
    --muted: 0 0% 96.1%;
    --muted-foreground: 0 0% 45.1%;
    --accent: 245 25% 54%;
    --accent-foreground: 0 0% 9%;
    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 0 0% 98%;
    --border: 0 0% 89.8%;
    --input: 0 0% 89.8%;
    --ring: 0 0% 3.9%;
    --radius: 0.5rem;
    --chart-1: 12 76% 61%;
    --chart-2: 173 58% 39%;
    --chart-3: 197 37% 24%;
    --chart-4: 43 74% 66%;
    --chart-5: 27 87% 67%;
  }
  .dark {
    --background: 0 0% 100%;
    --backgroundButton: var(--persimmon);
    --backgroundButtonDate: var(--karry);
    --backgroundCard: var(--salmon);
    --backgroundDatePicker: var(--seashellPeach);
    --backgroundInvert: var(--white);
    --backgroundHeader: var(--white);
    --backgroundSecondary: var(--seashellPeach);
    --backgroundSelect: var(--macaroniAndCheese);
    --foreground: var(--matterhorn);
    --card: 0 0% 3.9%;
    --card-foreground: 0 0% 98%;
    --card-border: 0 0% 80%;
    --tw-text-opacity: 0, 0%, 67%;
    --popover: 0 0% 3.9%;
    --popover-foreground: 0 0% 98%;
    --primary: 0 0% 98%;
    --primary-foreground: 0 0% 9%;
    --secondary: 0 0% 14.9%;
    --secondary-foreground: 0 0% 98%;
    --tab: hsla(324, 13%, 23%, 0.6);
    --tabActive: hsla(15, 91%, 61%, 0.6);
    --tabActiveSecondary: hsla(28, 100%, 75%, 0.6);
    --textInvert: var(--white);
    --textPlaceholder: var(--macaroniAndCheese);
    --textPrimary: var(--matterhorn);
    --textSecondary: var(--persimmon);
    --textThird: var(--salmon);
    --pagination: hsl(var(--karry));
    --paginationActive: var(--macaroniAndCheese);
    --muted: 0 0% 14.9%;
    --muted-foreground: 0 0% 63.9%;
    --accent: 0 0% 14.9%;
    --accent-foreground: 0 0% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 0 0% 98%;
    --border: 0 0% 14.9%;
    --input: 0 0% 14.9%;
    --ring: 0 0% 83.1%;
    --chart-1: 220 70% 50%;
    --chart-2: 160 60% 45%;
    --chart-3: 30 80% 55%;
    --chart-4: 280 65% 60%;
    --chart-5: 340 75% 55%;
  }
  .collapsibleDropdown {
    overflow: hidden;
  }
  .collapsibleDropdown[data-state="open"] {
    animation: slideDown 200ms ease-out;
  }
  .collapsibleDropdown[data-state="closed"] {
    animation: slideUp 200ms ease-out;
  }
  * {
    border-color: var(--color-border);
  }
  body {
    min-height: 100svh;
    width: 100%;
    background-color: var(--color-background);
    color: var(--color-foreground);
    font-family: "Montserrat", sans-serif;
    font-optical-sizing: auto;
    font-weight: 500;
    font-size: 14px;
    line-height: 122%;
    font-style: normal;
  }
  body > #root {
    height: 100svh;
  }
  @media screen and (max-width: 767px) {
    input,
    select,
    textarea {
      font-size: 16px !important;
    }
  }
}
@layer base {
  * {
    border-color: var(--color-border);
  }
  body {
    background-color: var(--color-background);
    color: var(--color-foreground);
  }
}
body,
html {
  overflow-y: scroll;
  scrollbar-width: none;
  color: "red";
}
body::-webkit-scrollbar {
  display: none;
}
.hide-horizontal-scrollbar {
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.hide-horizontal-scrollbar::-webkit-scrollbar {
  display: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
pre {
  font-family: Arial, serif;
}
html {
  overflow: visible;
}
.swiper-pagination-bullet-active {
  background-color: hsl(var(--matterhorn));
}
.myPagination {
  display: flex;
  justify-content: center;
}
.myPagination span {
  background-color: var(--pagination);
  margin: 0 0 !important;
  border-radius: 1px;
  transition: background 0.3s;
}
.myPagination span.swiper-pagination-bullet-active {
  background-color: var(--paginationActive);
}
.object-bottom-left {
  object-position: left bottom;
}
.scroll {
  position: relative;
  overflow: auto;
  z-index: 100;
}
.scroll::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll::-webkit-scrollbar-button {
  display: none;
}
.scroll::-webkit-scrollbar-track {
  background: transparent;
  margin-left: 15px;
  margin-right: 15px;
}
.scroll::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 5px;
}
.scroll::-webkit-scrollbar-thumb:hover {
  background: hsl(var(--persimmon));
  cursor: pointer;
}
.scroll::-webkit-scrollbar-corner {
  background: var(--salmon);
}
.scroll {
  scrollbar-width: thin;
  scrollbar-color: var(--salmon) transparent;
  border-radius: 5px;
}
.toaster-custom {
  z-index: 1000 !important;
}
@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-pan-x {
  syntax: "*";
  inherits: false;
}
@property --tw-pan-y {
  syntax: "*";
  inherits: false;
}
@property --tw-pinch-zoom {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-content: "";
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-pan-x: initial;
      --tw-pan-y: initial;
      --tw-pinch-zoom: initial;
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-divide-x-reverse: 0;
      --tw-border-style: solid;
      --tw-divide-y-reverse: 0;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui-components/src/input.css"],"names":[],"mappings":"AAAA,gEA2XA;AA3XA,iBA2XA;AA3XA,yCA2XA;AA3XA;EAAA;IAAA;6DA2XA;IA3XA,yEA2XA;IA3XA;8BA2XA;IA3XA,wCA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,2CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,6CA2XA;IA3XA,8CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,2CA2XA;IA3XA,0CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,4CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,8CA2XA;IA3XA,6CA2XA;IA3XA,8CA2XA;IA3XA,+CA2XA;IA3XA,+CA2XA;IA3XA,6CA2XA;IA3XA,+CA2XA;IA3XA,+CA2XA;IA3XA,+CA2XA;IA3XA,8CA2XA;IA3XA,+CA2XA;IA3XA,0CA2XA;IA3XA,4CA2XA;IA3XA,0CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,0CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,yCA2XA;IA3XA,2CA2XA;IA3XA,2CA2XA;IA3XA,2CA2XA;IA3XA,0CA2XA;IA3XA,2CA2XA;IA3XA,2CA2XA;IA3XA,yCA2XA;IA3XA,yCA2XA;IA3XA,0CA2XA;IA3XA,2CA2XA;IA3XA,yCA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,6CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,6CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,6CA2XA;IA3XA,8CA2XA;IA3XA,6CA2XA;IA3XA,8CA2XA;IA3XA,4CA2XA;IA3XA,8CA2XA;IA3XA,6CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,4CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,8CA2XA;IA3XA,+CA2XA;IA3XA,8CA2XA;IA3XA,+CA2XA;IA3XA,4CA2XA;IA3XA,8CA2XA;IA3XA,+CA2XA;IA3XA,+CA2XA;IA3XA,+CA2XA;IA3XA,8CA2XA;IA3XA,+CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,yCA2XA;IA3XA,2CA2XA;IA3XA,yCA2XA;IA3XA,2CA2XA;IA3XA,2CA2XA;IA3XA,2CA2XA;IA3XA,2CA2XA;IA3XA,2CA2XA;IA3XA,yCA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,4CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,0CA2XA;IA3XA,0CA2XA;IA3XA,iCA2XA;IA3XA,4CA2XA;IA3XA,yCA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,0CA2XA;IA3XA,4CA2XA;IA3XA,0CA2XA;IA3XA,4CA2XA;IA3XA,oCA2XA;IA3XA,mCA2XA;IA3XA,qCA2XA;IA3XA,mCA2XA;IA3XA,qCA2XA;IA3XA,qCA2XA;IA3XA,qCA2XA;IA3XA,qCA2XA;IA3XA,qCA2XA;IA3XA,qCA2XA;IA3XA,qCA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,4CA2XA;IA3XA,2CA2XA;IA3XA,mBA2XA;IA3XA,mBA2XA;IA3XA,kBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,uBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,qBA2XA;IA3XA,qBA2XA;IA3XA,qBA2XA;IA3XA,qBA2XA;IA3XA,qBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,kBA2XA;IA3XA,sCA2XA;IA3XA,mBA2XA;IA3XA,0CA2XA;IA3XA,iBA2XA;IA3XA,uCA2XA;IA3XA,mBA2XA;IA3XA,0CA2XA;IA3XA,kBA2XA;IA3XA,yCA2XA;IA3XA,kBA2XA;IA3XA,sCA2XA;IA3XA,oBA2XA;IA3XA,2CA2XA;IA3XA,mBA2XA;IA3XA,yCA2XA;IA3XA,gBA2XA;IA3XA,0BA2XA;IA3XA,mBA2XA;IA3XA,0BA2XA;IA3XA,kBA2XA;IA3XA,0BA2XA;IA3XA,gBA2XA;IA3XA,0BA2XA;IA3XA,gBA2XA;IA3XA,0BA2XA;IA3XA,uBA2XA;IA3XA,6BA2XA;IA3XA,wBA2XA;IA3XA,yBA2XA;IA3XA,yBA2XA;IA3XA,2BA2XA;IA3XA,uBA2XA;IA3XA,4BA2XA;IA3XA,wBA2XA;IA3XA,2BA2XA;IA3XA,0BA2XA;IA3XA,sBA2XA;IA3XA,wBA2XA;IA3XA,wBA2XA;IA3XA,wBA2XA;IA3XA,qBA2XA;IA3XA,qBA2XA;IA3XA,qBA2XA;IA3XA,wBA2XA;IA3XA,kBA2XA;IA3XA,qBA2XA;IA3XA,sCA2XA;IA3XA,sCA2XA;IA3XA,0BA2XA;IA3XA,oBA2XA;IA3XA,kBA2XA;IA3XA,oBA2XA;IA3XA,kBA2XA;IA3XA,qCA2XA;IA3XA,0CA2XA;IA3XA,0EA2XA;IA3XA,6EA2XA;IA3XA,+EA2XA;IA3XA,gFA2XA;IA3XA,iDA2XA;IA3XA,iDA2XA;IA3XA,oDA2XA;IA3XA,oDA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,6CA2XA;IA3XA,4CA2XA;IA3XA,gDA2XA;IA3XA,gDA2XA;IA3XA,8CA2XA;IA3XA;oCA2XA;IA3XA;kCA2XA;IA3XA;kCA2XA;IA3XA,qCA2XA;IA3XA,sCA2XA;IA3XA,2CA2XA;IA3XA,uCA2XA;IA3XA,2DA2XA;IA3XA,+DA2XA;IA3XA,oCA2XA;IA3XA,cA2XA;IA3XA,cA2XA;IA3XA,eA2XA;IA3XA,eA2XA;IA3XA,eA2XA;IA3XA,gBA2XA;IA3XA,gBA2XA;IA3XA,6BA2XA;IA3XA,yBA2XA;IA3XA,2BA2XA;IA3XA,6BA2XA;IA3XA,6BA2XA;IA3XA,sBA2XA;IA3XA,oCA2XA;IA3XA,kEA2XA;IA3XA,uCA2XA;IA3XA,4CA2XA;IA3XA,yCA2XA;IA3XA,6CA2XA;IA3XA,0CA2XA;IA3XA,uDA2XA;IA3XA,gEA2XA;IA3XA,2DA2XA;IA3XA,8CA2XA;IA3XA,kDA2XA;IA3XA,wDA2XA;IA3XA,kDA2XA;IA3XA,0CA2XA;IA3XA,8BA2XA;IA3XA,qCA2XA;IA3XA,oDA2XA;IA3XA,oCA2XA;IA3XA,0DA2XA;IA3XA,oCA2XA;IA3XA,0DA2XA;IA3XA,wCA2XA;IA3XA,8DA2XA;IA3XA,gCA2XA;IA3XA,sDA2XA;IA3XA,kCA2XA;IA3XA,wDA2XA;IA3XA,4CA2XA;IA3XA,kEA2XA;IA3XA,kCA2XA;IA3XA,gCA2XA;IA3XA,8BA2XA;IA3XA,oCA2XA;IA3XA,oCA2XA;IA3XA,oCA2XA;IA3XA,oCA2XA;IA3XA,oCA2XA;IA3XA,sCA2XA;IA3XA,gDA2XA;IA3XA,6CA2XA;IA3XA,iDA2XA;IA3XA,oCA2XA;EAAA;AAAA;AA3XA;EAAA;IAAA,sBA2XA;IA3XA,SA2XA;IA3XA,UA2XA;IA3XA,eA2XA;EAAA;EA3XA;IAAA,gBA2XA;IA3XA,8BA2XA;IA3XA,WA2XA;IA3XA,2JA2XA;IA3XA,mEA2XA;IA3XA,uEA2XA;IA3XA,wCA2XA;EAAA;EA3XA;IAAA,SA2XA;IA3XA,cA2XA;IA3XA,qBA2XA;EAAA;EA3XA;IAAA,yCA2XA;IA3XA,iCA2XA;EAAA;EA3XA;IAAA,kBA2XA;IA3XA,oBA2XA;EAAA;EA3XA;IAAA,cA2XA;IA3XA,gCA2XA;IA3XA,wBA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,gJA2XA;IA3XA,wEA2XA;IA3XA,4EA2XA;IA3XA,cA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA,cA2XA;IA3XA,cA2XA;IA3XA,kBA2XA;IA3XA,wBA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,cA2XA;IA3XA,qBA2XA;IA3XA,yBA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,wBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,cA2XA;IA3XA,sBA2XA;EAAA;EA3XA;IAAA,eA2XA;IA3XA,YA2XA;EAAA;EA3XA;IAAA,aA2XA;IA3XA,8BA2XA;IA3XA,gCA2XA;IA3XA,uBA2XA;IA3XA,cA2XA;IA3XA,gBA2XA;IA3XA,6BA2XA;IA3XA,UA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,0BA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA;MAAA,mBA2XA;MA3XA;QAAA,yDA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,wBA2XA;EAAA;EA3XA;IAAA,eA2XA;IA3XA,mBA2XA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,wBA2XA;EAAA;AAAA;AA3XA;EAAA;IAAA;MAAA,0BA2XA;MA3XA,oBA2XA;IAAA;IA3XA;MAAA,0BA2XA;MA3XA,kBA2XA;IAAA;IA3XA;MAAA,0BA2XA;MA3XA,gCA2XA;IAAA;IA3XA;MAAA,0BA2XA;MA3XA,8BA2XA;IAAA;IA3XA;MAAA,0BA2XA;MA3XA,aA2XA;IAAA;IA3XA;MAAA,0BA2XA;MA3XA,iCA2XA;IAAA;IA3XA;MAAA,0BA2XA;MA3XA,WA2XA;IAAA;IA3XA;MAAA,0BA2XA;MA3XA,sFA2XA;IAAA;IA3XA;MAAA;QAAA,0BA2XA;QA3XA,cA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,kBA2XA;IA3XA,UA2XA;IA3XA,WA2XA;IA3XA,UA2XA;IA3XA,YA2XA;IA3XA,gBA2XA;IA3XA,sBA2XA;IA3XA,mBA2XA;IA3XA,eA2XA;EAAA;EA3XA;IAAA,gBA2XA;IA3XA,WA2XA;IA3XA,YA2XA;IA3XA,UA2XA;IA3XA,SA2XA;IA3XA,iBA2XA;IA3XA,UA2XA;IA3XA,mBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA,SA2XA;EAAA;EA3XA;IAAA,QA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA,SA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,WA2XA;IA3XA;MAAA,gBA2XA;IAAA;IA3XA;MAAA,gBA2XA;IAAA;IA3XA;MAAA,gBA2XA;IAAA;IA3XA;MAAA,gBA2XA;IAAA;IA3XA;MAAA,gBA2XA;IAAA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,gBA2XA;IA3XA,oBA2XA;IA3XA,4BA2XA;IA3XA,qBA2XA;EAAA;EA3XA;IAAA,gBA2XA;IA3XA,oBA2XA;IA3XA,4BA2XA;IA3XA,qBA2XA;EAAA;EA3XA;IAAA;MAAA,aA2XA;IAAA;IA3XA,wBA2XA;IA3XA,qBA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,2BA2XA;EAAA;EA3XA;IAAA,2BA2XA;EAAA;EA3XA;IAAA,2BA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,wBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,wBA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,0CA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,uBA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,uBA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,mCA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,4CA2XA;EAAA;EA3XA;IAAA,OA2XA;EAAA;EA3XA;IAAA,UA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,2CA2XA;IA3XA,sDA2XA;EAAA;EA3XA;IAAA,6CA2XA;IA3XA,sDA2XA;EAAA;EA3XA;IAAA,sBA2XA;IA3XA,sDA2XA;EAAA;EA3XA;IAAA,2CA2XA;IA3XA,sDA2XA;EAAA;EA3XA;IAAA,6CA2XA;IA3XA,sDA2XA;EAAA;EA3XA;IAAA,0CA2XA;IA3XA,sDA2XA;EAAA;EA3XA;IAAA,kCA2XA;IA3XA,sDA2XA;EAAA;EA3XA;IAAA,sBA2XA;IA3XA,sDA2XA;EAAA;EA3XA;IAAA,0GA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,2BA2XA;IA3XA,qEA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,gDA2XA;EAAA;EA3XA;IAAA,gDA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,uBA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,uBA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,QA2XA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;MA3XA,8EA2XA;MA3XA,sFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;MA3XA,gFA2XA;MA3XA,wFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;MA3XA,8EA2XA;MA3XA,sFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;MA3XA,8EA2XA;MA3XA,sFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;MA3XA,8EA2XA;MA3XA,sFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;MA3XA,8EA2XA;MA3XA,sFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;MA3XA,+EA2XA;MA3XA,uFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;MA3XA,+EA2XA;MA3XA,uFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wBA2XA;MA3XA,2CA2XA;MA3XA,iEA2XA;MA3XA,yEA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wBA2XA;MA3XA,2CA2XA;MA3XA,wCA2XA;MA3XA,wDA2XA;MA3XA,qEA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wBA2XA;IAAA;EAAA;EA3XA;IAAA,gBA2XA;IA3XA,uBA2XA;IA3XA,mBA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,mCA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,kCA2XA;IA3XA,gCA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,gCA2XA;IA3XA,8BA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,+BA2XA;IA3XA,gCA2XA;EAAA;EA3XA;IAAA,yCA2XA;IA3XA,0CA2XA;EAAA;EA3XA;IAAA,+BA2XA;IA3XA,kCA2XA;EAAA;EA3XA;IAAA,4CA2XA;IA3XA,+CA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,gCA2XA;IA3XA,mCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,mCA2XA;IA3XA,kCA2XA;EAAA;EA3XA;IAAA,6CA2XA;IA3XA,4CA2XA;EAAA;EA3XA;IAAA,mCA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,oCA2XA;IA3XA,iBA2XA;EAAA;EA3XA;IAAA,oCA2XA;IA3XA,iBA2XA;EAAA;EA3XA;IAAA,oCA2XA;IA3XA,iBA2XA;EAAA;EA3XA;IAAA,2CA2XA;IA3XA,wBA2XA;EAAA;EA3XA;IAAA,0CA2XA;IA3XA,uBA2XA;EAAA;EA3XA;IAAA,iDA2XA;IA3XA,8BA2XA;EAAA;EA3XA;IAAA,+CA2XA;IA3XA,4BA2XA;EAAA;EA3XA;IAAA,wCA2XA;IA3XA,qBA2XA;EAAA;EA3XA;IAAA,0CA2XA;IA3XA,uBA2XA;EAAA;EA3XA;IAAA,2CA2XA;IA3XA,wBA2XA;EAAA;EA3XA;IAAA,yCA2XA;IA3XA,sBA2XA;EAAA;EA3XA;IAAA,uBA2XA;IA3XA,kBA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,6CA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,4CA2XA;EAAA;EA3XA;IAAA,6CA2XA;EAAA;EA3XA;IAAA,4BA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,gDA2XA;EAAA;EA3XA;IAAA,qDA2XA;EAAA;EA3XA;IAAA,8CA2XA;EAAA;EA3XA;IAAA,qDA2XA;EAAA;EA3XA;IAAA,gDA2XA;EAAA;EA3XA;IAAA,mDA2XA;EAAA;EA3XA;IAAA,gDA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,2DA2XA;IA3XA;MAAA,0EA2XA;IAAA;EAAA;EA3XA;IAAA,2DA2XA;IA3XA;MAAA,0EA2XA;IAAA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,mCA2XA;EAAA;EA3XA;IAAA,0CA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,wEA2XA;IA3XA;MAAA,0EA2XA;IAAA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,iFA2XA;IA3XA;MAAA,6EA2XA;IAAA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,gCA2XA;IA3XA;MAAA,yCA2XA;IAAA;IA3XA,2DA2XA;EAAA;EA3XA;IAAA,mEA2XA;EAAA;EA3XA;IAAA,kGA2XA;EAAA;EA3XA;IAAA,yCA2XA;IA3XA,8LA2XA;EAAA;EA3XA;IAAA,uCA2XA;IA3XA,8LA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,2BA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,0BA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,4BA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,mCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,0CA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,uCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,0CA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,yCA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,qBA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,0BA2XA;IA3XA,4DA2XA;EAAA;EA3XA;IAAA,0BA2XA;IA3XA,4DA2XA;EAAA;EA3XA;IAAA,yBA2XA;IA3XA,2DA2XA;EAAA;EA3XA;IAAA,yBA2XA;IA3XA,2DA2XA;EAAA;EA3XA;IAAA,yBA2XA;IA3XA,2DA2XA;EAAA;EA3XA;IAAA,yBA2XA;IA3XA,2DA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,kBA2XA;IA3XA,iBA2XA;EAAA;EA3XA;IAAA,kBA2XA;IA3XA,iBA2XA;EAAA;EA3XA;IAAA,kBA2XA;IA3XA,iBA2XA;EAAA;EA3XA;IAAA,kBA2XA;IA3XA,iBA2XA;EAAA;EA3XA;IAAA,eA2XA;IA3XA,cA2XA;EAAA;EA3XA;IAAA,yCA2XA;IA3XA,oCA2XA;EAAA;EA3XA;IAAA,2CA2XA;IA3XA,sCA2XA;EAAA;EA3XA;IAAA,2CA2XA;IA3XA,sCA2XA;EAAA;EA3XA;IAAA,6CA2XA;IA3XA,wCA2XA;EAAA;EA3XA;IAAA,oCA2XA;IA3XA,qCA2XA;EAAA;EA3XA;IAAA,qCA2XA;IA3XA,sCA2XA;EAAA;EA3XA;IAAA,iBA2XA;EAAA;EA3XA;IAAA,eA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,uBA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,4BA2XA;EAAA;EA3XA;IAAA,mCA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,0CA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,4BA2XA;EAAA;EA3XA;IAAA,4BA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,2BA2XA;EAAA;EA3XA;IAAA,sCA2XA;EAAA;EA3XA;IAAA,2BA2XA;EAAA;EA3XA;IAAA,2BA2XA;EAAA;EA3XA;IAAA,wCA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,oCA2XA;EAAA;EA3XA;IAAA,gCA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,0BA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,oBA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA,yCA2XA;IA3XA,iJA2XA;EAAA;EA3XA;IAAA,gCA2XA;IA3XA,iJA2XA;EAAA;EA3XA;IAAA,kCA2XA;IA3XA,iJA2XA;EAAA;EA3XA;IAAA,qBA2XA;IA3XA,iJA2XA;EAAA;EA3XA;IAAA,uCA2XA;IA3XA,iJA2XA;EAAA;EA3XA;IAAA,+BA2XA;IA3XA,iJA2XA;EAAA;EA3XA;IAAA,wCA2XA;IA3XA,iJA2XA;EAAA;EA3XA;IAAA,kCA2XA;IA3XA,iJA2XA;EAAA;EA3XA;IAAA,4BA2XA;EAAA;EA3XA;IAAA,kCA2XA;EAAA;EA3XA;IAAA,0BA2XA;EAAA;EA3XA;IAAA,8BA2XA;EAAA;EA3XA;IAAA,+BA2XA;EAAA;EA3XA;IAAA,0BA2XA;EAAA;EA3XA;IAAA,mCA2XA;IA3XA,kCA2XA;EAAA;EA3XA;IAAA,4BA2XA;IA3XA,6BA2XA;EAAA;EA3XA;IAAA,WA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,YA2XA;EAAA;EA3XA;IAAA,aA2XA;EAAA;EA3XA;IAAA,0HA2XA;IA3XA,sIA2XA;EAAA;EA3XA;IAAA,+HA2XA;IA3XA,sIA2XA;EAAA;EA3XA;IAAA,6HA2XA;IA3XA,sIA2XA;EAAA;EA3XA;IAAA,sBA2XA;IA3XA,sIA2XA;EAAA;EA3XA;IAAA,0HA2XA;IA3XA,sIA2XA;EAAA;EA3XA;IAAA,kEA2XA;IA3XA,sIA2XA;EAAA;EA3XA;IAAA,wHA2XA;IA3XA,sIA2XA;EAAA;EA3XA;IAAA,wHA2XA;IA3XA,sIA2XA;EAAA;EA3XA;IAAA,+CA2XA;EAAA;EA3XA;IAAA,wBA2XA;IA3XA,mBA2XA;IA3XA;MAAA,8BA2XA;MA3XA,mBA2XA;IAAA;EAAA;EA3XA;IAAA,sCA2XA;IA3XA,kBA2XA;EAAA;EA3XA;IAAA,oBA2XA;IA3XA,0LA2XA;EAAA;EA3XA;IAAA,gCA2XA;IA3XA,0LA2XA;EAAA;EA3XA;IAAA,iKA2XA;IA3XA,mGA2XA;IA3XA,0LA2XA;EAAA;EA3XA;IAAA,+BA2XA;IA3XA,0LA2XA;EAAA;EA3XA;IAAA,yBA2XA;IA3XA,0LA2XA;EAAA;EA3XA;IAAA,uBA2XA;IA3XA,0LA2XA;EAAA;EA3XA;IAAA,0LA2XA;EAAA;EA3XA;IAAA,6BA2XA;IA3XA,wRA2XA;IA3XA,gRA2XA;EAAA;EA3XA;IAAA,wCA2XA;IA3XA,wRA2XA;IA3XA,gRA2XA;EAAA;EA3XA;IAAA,kCA2XA;IA3XA,wRA2XA;IA3XA,gRA2XA;EAAA;EA3XA;IAAA,gCA2XA;IA3XA,wRA2XA;IA3XA,gRA2XA;EAAA;EA3XA;IAAA,wRA2XA;IA3XA,gRA2XA;EAAA;EA3XA;IAAA,mRA2XA;IA3XA,qFA2XA;IA3XA,2EA2XA;EAAA;EA3XA;IAAA,wBA2XA;IA3XA,qFA2XA;IA3XA,2EA2XA;EAAA;EA3XA;IAAA,uKA2XA;IA3XA,qFA2XA;IA3XA,2EA2XA;EAAA;EA3XA;IAAA,4BA2XA;IA3XA,qFA2XA;IA3XA,2EA2XA;EAAA;EA3XA;IAAA,wDA2XA;IA3XA,qFA2XA;IA3XA,2EA2XA;EAAA;EA3XA;IAAA,oBA2XA;IA3XA,0BA2XA;EAAA;EA3XA;IAAA,oBA2XA;IA3XA,0BA2XA;EAAA;EA3XA;IAAA,oBA2XA;IA3XA,0BA2XA;EAAA;EA3XA;IAAA,6BA2XA;IA3XA,8CA2XA;EAAA;EA3XA;IAAA,0BA2XA;IA3XA,2CA2XA;EAAA;EA3XA;IAAA,yBA2XA;IA3XA,iBA2XA;EAAA;EA3XA;IAAA,2BA2XA;EAAA;EA3XA;IAAA;MAAA,wBA2XA;IAAA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,yBA2XA;EAAA;EA3XA;IAAA,uDA2XA;EAAA;EA3XA;IAAA,qDA2XA;EAAA;EA3XA;IAAA,4BA2XA;EAAA;EA3XA;IAAA,sBA2XA;EAAA;EA3XA;IAAA,6BA2XA;EAAA;EA3XA;IAAA,mBA2XA;EAAA;EA3XA;IAAA,kBA2XA;EAAA;EA3XA;IAAA;MAAA,mBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,YA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;MA3XA,iBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,6BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yBA2XA;MA3XA,2DA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yBA2XA;MA3XA,2DA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,eA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yCA2XA;MA3XA,oCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,kCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,8BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,kBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,qBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,sBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,YA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,gBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,WA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,eA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,6CA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,6CA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,gBA2XA;MA3XA,0BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,oBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,kBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,gCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,8BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,aA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,iCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,WA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0BA2XA;MA3XA,sFA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,kBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,WA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,kBA2XA;QA3XA,kBA2XA;QA3XA,kBA2XA;QA3XA,0CA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,yBA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,qCA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,gDA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,8CA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,gDA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,gDA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,8EA2XA;QA3XA;UAAA,gFA2XA;QAAA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,8EA2XA;QA3XA;UAAA,gFA2XA;QAAA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,uCA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,uCA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,oCA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,wEA2XA;QA3XA;UAAA,0EA2XA;QAAA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,iFA2XA;QA3XA;UAAA,6EA2XA;QAAA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,0EA2XA;QA3XA;UAAA,4EA2XA;QAAA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,sCA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,4EA2XA;QA3XA;UAAA,8EA2XA;QAAA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,qCA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,sCA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,+BA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,8BA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,yBA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,+BA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,YA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,aA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,gIA2XA;QA3XA,sIA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA,gDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,gDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,sCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,sBA2XA;MA3XA,sIA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wHA2XA;MA3XA,sIA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,kCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,2BA2XA;MA3XA,4GA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wBA2XA;MA3XA,mBA2XA;MA3XA;QAAA,8BA2XA;QA3XA,mBA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA,wHA2XA;MA3XA,sIA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wHA2XA;MA3XA,sIA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,kCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,2BA2XA;MA3XA,4GA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+CA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wBA2XA;MA3XA,mBA2XA;MA3XA;QAAA,8BA2XA;QA3XA,mBA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,mBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,YA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,YA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yEA2XA;MA3XA;QAAA,2EA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA,gDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,aA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,YA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,YA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,kCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,sBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,iCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0CA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,2CA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,8BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0CA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,2CA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,gCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,8BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,gDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0HA2XA;MA3XA,sIA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0CA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,sCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,iBA2XA;MA3XA,iBA2XA;MA3XA,iBA2XA;MA3XA,0CA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;MA3XA,yBA2XA;MA3XA,0BA2XA;MA3XA,wBA2XA;MA3XA,yBA2XA;MA3XA,8BA2XA;MA3XA,8BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,2BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,2BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,kBA2XA;MA3XA,kBA2XA;MA3XA,kBA2XA;MA3XA,0CA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qBA2XA;MA3XA,yBA2XA;MA3XA,2BA2XA;MA3XA,yBA2XA;MA3XA,0BA2XA;MA3XA,+BA2XA;MA3XA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,4BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,4BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,0CA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,mBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,uBA2XA;QA3XA,+EA2XA;QA3XA,uFA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,gBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yBA2XA;MA3XA,2DA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,2CA2XA;MA3XA,sCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,gCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,iCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,gCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;MA3XA,gCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,cA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,2CA2XA;MA3XA,wBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oCA2XA;MA3XA,iBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,yCA2XA;MA3XA,4CA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,wCA2XA;MA3XA,2CA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,wCA2XA;QA3XA,2CA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,yCA2XA;QA3XA,4CA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA,yEA2XA;MA3XA;QAAA,2EA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA,yCA2XA;MA3XA,4CA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,uCA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qBA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,gBA2XA;MA3XA,oBA2XA;MA3XA,4BA2XA;MA3XA,qBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA;QAAA,2CA2XA;QA3XA,wBA2XA;MAAA;IAAA;EAAA;EA3XA;IAAA;MAAA,gCA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,gCA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,iBA2XA;MA3XA,iBA2XA;MA3XA,iBA2XA;MA3XA,0CA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;MA3XA,yBA2XA;MA3XA,0BA2XA;MA3XA,wBA2XA;MA3XA,yBA2XA;MA3XA,8BA2XA;MA3XA,8BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,oBA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qBA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qBA2XA;MA3XA,sDA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,kBA2XA;MA3XA,kBA2XA;MA3XA,kBA2XA;MA3XA,0CA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qBA2XA;MA3XA,yBA2XA;MA3XA,2BA2XA;MA3XA,yBA2XA;MA3XA,0BA2XA;MA3XA,+BA2XA;MA3XA,+BA2XA;IAAA;EAAA;EA3XA;IAAA;MAAA,qBA2XA;IAAA;EAAA;AAAA;AA3XA;EAAA,sBA2XA;EA3XA,2BA2XA;EA3XA,6BA2XA;EA3XA,kCA2XA;EA3XA,qCA2XA;EA3XA,gCA2XA;EA3XA,qCA2XA;EA3XA,uCA2XA;EA3XA,yBA2XA;EA3XA,0CA2XA;EA3XA,gDA2XA;AAAA;AA3XA;EAAA,6EA2XA;AAAA;AA3XA;EAAA,iFA2XA;AAAA;AA3XA;EAAA,yDA2XA;AAAA;AA3XA;EAAA,kEA2XA;AAAA;AA3XA;EAAA,mGA2XA;AAAA;AA3XA;EAAA,4EA2XA;AAAA;AA3XA;EAAA,+CA2XA;AAAA;AA3XA;EAAA,iDA2XA;AAAA;AA3XA;EAAA,2BA2XA;AAAA;AA3XA;EAAA,kBA2XA;EA3XA,iBA2XA;EA3XA,kBA2XA;EA3XA,WA2XA;EA3XA,YA2XA;EA3XA,8BA2XA;EA3XA,8DA2XA;AAAA;AA3XA;EAAA;;;;;IAAA,iDA2XA;EAAA;AAAA;AA3XA;EAAA;IAAA,qBA2XA;IA3XA,wBA2XA;IA3XA,uBA2XA;IA3XA,oCA2XA;IA3XA,oCA2XA;IA3XA,+BA2XA;IA3XA,4CA2XA;IA3XA,gCA2XA;IA3XA,gCA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,+BA2XA;IA3XA,iBA2XA;IA3XA,4BA2XA;IA3XA,oBA2XA;IA3XA,+BA2XA;IA3XA,kBA2XA;IA3XA,8BA2XA;IA3XA,uBA2XA;IA3XA,+BA2XA;IA3XA,+BA2XA;IA3XA,oCA2XA;IA3XA,8CA2XA;IA3XA,0BA2XA;IA3XA,2CA2XA;IA3XA,gCA2XA;IA3XA,iCA2XA;IA3XA,0BA2XA;IA3XA,+BA2XA;IA3XA,4CA2XA;IA3XA,mBA2XA;IA3XA,8BA2XA;IA3XA,qBA2XA;IA3XA,4BA2XA;IA3XA,4BA2XA;IA3XA,kCA2XA;IA3XA,oBA2XA;IA3XA,mBA2XA;IA3XA,iBA2XA;IA3XA,gBA2XA;IA3XA,qBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,qBA2XA;IA3XA,qBA2XA;EAAA;EA3XA;IAAA,uBA2XA;IA3XA,oCA2XA;IA3XA,oCA2XA;IA3XA,+BA2XA;IA3XA,4CA2XA;IA3XA,gCA2XA;IA3XA,gCA2XA;IA3XA,2CA2XA;IA3XA,4CA2XA;IA3XA,+BA2XA;IA3XA,iBA2XA;IA3XA,2BA2XA;IA3XA,uBA2XA;IA3XA,6BA2XA;IA3XA,oBA2XA;IA3XA,8BA2XA;IA3XA,mBA2XA;IA3XA,6BA2XA;IA3XA,uBA2XA;IA3XA,gCA2XA;IA3XA,+BA2XA;IA3XA,oCA2XA;IA3XA,8CA2XA;IA3XA,0BA2XA;IA3XA,2CA2XA;IA3XA,gCA2XA;IA3XA,iCA2XA;IA3XA,0BA2XA;IA3XA,+BA2XA;IA3XA,4CA2XA;IA3XA,mBA2XA;IA3XA,8BA2XA;IA3XA,oBA2XA;IA3XA,6BA2XA;IA3XA,4BA2XA;IA3XA,kCA2XA;IA3XA,oBA2XA;IA3XA,mBA2XA;IA3XA,kBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;IA3XA,qBA2XA;IA3XA,sBA2XA;IA3XA,sBA2XA;EAAA;EA3XA;IAAA,gBA2XA;EAAA;EA3XA;IAAA,mCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,kBA2XA;IA3XA,WA2XA;IA3XA,yCA2XA;IA3XA,8BA2XA;IA3XA,qCA2XA;IA3XA,yBA2XA;IA3XA,gBA2XA;IA3XA,eA2XA;IA3XA,iBA2XA;IA3XA,kBA2XA;EAAA;EA3XA;IAAA,cA2XA;EAAA;EA3XA;IAAA;;;MAAA,0BA2XA;IAAA;EAAA;AAAA;AA3XA;EAAA;IAAA,iCA2XA;EAAA;EA3XA;IAAA,yCA2XA;IA3XA,8BA2XA;EAAA;AAAA;AA3XA;;EAAA,kBA2XA;EA3XA,qBA2XA;EA3XA,YA2XA;AAAA;AA3XA;EAAA,aA2XA;AAAA;AA3XA;EAAA,kBA2XA;EA3XA,qBA2XA;EA3XA,wBA2XA;AAAA;AA3XA;EAAA,aA2XA;AAAA;AA3XA;;EAAA,wBA2XA;EA3XA,SA2XA;AAAA;AA3XA;EAAA,0BA2XA;AAAA;AA3XA;EAAA,yBA2XA;AAAA;AA3XA;EAAA,iBA2XA;AAAA;AA3XA;EAAA,wCA2XA;AAAA;AA3XA;EAAA,aA2XA;EA3XA,uBA2XA;AAAA;AA3XA;EAAA,mCA2XA;EA3XA,sBA2XA;EA3XA,kBA2XA;EA3XA,2BA2XA;AAAA;AA3XA;EAAA,yCA2XA;AAAA;AA3XA;EAAA,4BA2XA;AAAA;AA3XA;EAAA,kBA2XA;EA3XA,cA2XA;EA3XA,YA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,YA2XA;AAAA;AA3XA;EAAA,aA2XA;AAAA;AA3XA;EAAA,uBA2XA;EA3XA,iBA2XA;EA3XA,kBA2XA;AAAA;AA3XA;EAAA,uBA2XA;EA3XA,kBA2XA;AAAA;AA3XA;EAAA,iCA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,yBA2XA;AAAA;AA3XA;EAAA,qBA2XA;EA3XA,0CA2XA;EA3XA,kBA2XA;AAAA;AA3XA;EAAA,wBA2XA;AAAA;AA3XA;EAAA;IAAA,mCA2XA;IA3XA,iNA2XA;EAAA;AAAA;AA3XA;EAAA;IAAA,kCA2XA;IA3XA,2MA2XA;EAAA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,iBA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,oBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,iBA2XA;EA3XA,eA2XA;EA3XA,oBA2XA;AAAA;AA3XA;EAAA,iBA2XA;EA3XA,eA2XA;EA3XA,oBA2XA;AAAA;AA3XA;EAAA,iBA2XA;EA3XA,eA2XA;EA3XA,oBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,6BA2XA;EA3XA,eA2XA;EA3XA,iBA2XA;AAAA;AA3XA;EAAA,6BA2XA;EA3XA,eA2XA;EA3XA,kBA2XA;AAAA;AA3XA;EAAA,6BA2XA;EA3XA,eA2XA;EA3XA,mBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,wBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,sBA2XA;EA3XA,eA2XA;EA3XA,mBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,wBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,sBA2XA;EA3XA,eA2XA;EA3XA,mBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,wBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,wBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,kBA2XA;EA3XA,eA2XA;EA3XA,kBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,mBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,wBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,oBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,sBA2XA;EA3XA,eA2XA;EA3XA,mBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA,WA2XA;EA3XA,eA2XA;EA3XA,gBA2XA;AAAA;AA3XA;EAAA;IAAA,yBA2XA;EAAA;AAAA;AA3XA;EAAA;IAAA,mBA2XA;IA3XA,UA2XA;EAAA;AAAA;AA3XA;EAAA;IAAA,YA2XA;EAAA;AAAA;AA3XA;EAAA;IAAA,2BA2XA;IA3XA,qDA2XA;EAAA;EA3XA;IAAA,eA2XA;IA3XA,qDA2XA;EAAA;AAAA;AA3XA;EAAA;IAAA;MAAA,gBA2XA;MA3XA,mBA2XA;MA3XA,mBA2XA;MA3XA,mBA2XA;MA3XA,sBA2XA;MA3XA,sBA2XA;MA3XA,sBA2XA;MA3XA,oBA2XA;MA3XA,oBA2XA;MA3XA,mBA2XA;MA3XA,mBA2XA;MA3XA,wBA2XA;MA3XA,uBA2XA;MA3XA,uBA2XA;MA3XA,wBA2XA;MA3XA,wBA2XA;MA3XA,wBA2XA;MA3XA,+BA2XA;MA3XA,yBA2XA;MA3XA,wBA2XA;MA3XA,uBA2XA;MA3XA,4BA2XA;MA3XA,gCA2XA;MA3XA,+BA2XA;MA3XA,+BA2XA;MA3XA,+BA2XA;MA3XA,qBA2XA;MA3XA,yBA2XA;MA3XA,sBA2XA;MA3XA,qBA2XA;MA3XA,0BA2XA;MA3XA,4BA2XA;MA3XA,6BA2XA;MA3XA,8BA2XA;MA3XA,sBA2XA;MA3XA,0BA2XA;MA3XA,uBA2XA;MA3XA,4BA2XA;MA3XA,gCA2XA;MA3XA,6BA2XA;MA3XA,wBA2XA;MA3XA,2BA2XA;MA3XA,8BA2XA;MA3XA,iCA2XA;MA3XA,wBA2XA;MA3XA,2BA2XA;MA3XA,4BA2XA;MA3XA,kCA2XA;MA3XA,yBA2XA;MA3XA,kBA2XA;MA3XA,wBA2XA;MA3XA,sBA2XA;MA3XA,uBA2XA;MA3XA,wBA2XA;MA3XA,oBA2XA;MA3XA,qBA2XA;MA3XA,sBA2XA;MA3XA,mBA2XA;MA3XA,yBA2XA;MA3XA,+BA2XA;MA3XA,4BA2XA;MA3XA,8BA2XA;MA3XA,2BA2XA;MA3XA,iCA2XA;MA3XA,+BA2XA;MA3XA,gCA2XA;MA3XA,iCA2XA;MA3XA,6BA2XA;MA3XA,8BA2XA;MA3XA,+BA2XA;MA3XA,4BA2XA;MA3XA,sBA2XA;MA3XA,kBA2XA;MA3XA,eA2XA;MA3XA,eA2XA;MA3XA,eA2XA;IAAA;EAAA;AAAA","sourcesContent":["@import \"tailwindcss\";\n@import \"./styles/constants.css\";\n\n@plugin 'tailwindcss-animate';\n\n@custom-variant dark (&:is(.dark *));\n\n@theme {\n  --font-montserrat: Montserrat, sans-serif;\n  --font-press-start: \"Press Start 2P\", cursive;\n\n  --radius-lg: var(--radius);\n  --radius-md: calc(var(--radius) - 2px);\n  --radius-sm: calc(var(--radius) - 4px);\n\n  --color-background: hsl(var(--background));\n  --color-background-button: hsl(var(--backgroundButton));\n  --color-background-button-date: hsl(var(--backgroundButtonDate));\n  --color-background-date-picker: var(--backgroundDatePicker);\n  --color-background-card: var(--backgroundCard);\n  --color-background-invert: var(--backgroundInvert);\n  --color-background-secondary: var(--backgroundSecondary);\n  --color-background-select: var(--backgroundSelect);\n\n  --color-foreground: hsl(var(--foreground));\n\n  --color-card: hsl(var(--card));\n  --color-card-secondary: var(--salmon);\n  --color-card-foreground: hsl(var(--card-foreground));\n\n  --color-popover: hsl(var(--popover));\n  --color-popover-foreground: hsl(var(--popover-foreground));\n\n  --color-primary: hsl(var(--primary));\n  --color-primary-foreground: hsl(var(--primary-foreground));\n\n  --color-secondary: hsl(var(--secondary));\n  --color-secondary-foreground: hsl(var(--secondary-foreground));\n\n  --color-muted: hsl(var(--muted));\n  --color-muted-foreground: hsl(var(--muted-foreground));\n\n  --color-accent: hsl(var(--accent));\n  --color-accent-foreground: hsl(var(--accent-foreground));\n\n  --color-destructive: hsl(var(--destructive));\n  --color-destructive-foreground: hsl(var(--destructive-foreground));\n\n  --color-border: hsl(var(--border));\n  --color-input: hsl(var(--input));\n  --color-ring: hsl(var(--ring));\n\n  --color-chart-1: hsl(var(--chart-1));\n  --color-chart-2: hsl(var(--chart-2));\n  --color-chart-3: hsl(var(--chart-3));\n  --color-chart-4: hsl(var(--chart-4));\n  --color-chart-5: hsl(var(--chart-5));\n\n  --color-text-invert: var(--textInvert);\n  --color-text-placeholder: var(--textPlaceholder);\n  --color-text-primary: hsl(var(--textPrimary));\n  --color-text-secondary: hsl(var(--textSecondary));\n  --color-text-third: var(--textThird);\n}\n\n/*\n  The default border color has changed to `currentcolor` in Tailwind CSS v4,\n  so we've added these compatibility styles to make sure everything still\n  looks the same as it did with Tailwind CSS v3.\n\n  If we ever want to remove these styles, we need to add an explicit border\n  color utility to any element that depends on these defaults.\n*/\n@layer base {\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    border-color: var(--color-gray-200, currentcolor);\n  }\n}\n\n@utility no-scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  /* Hide scrollbar for IE, Edge and Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n@utility faded-bottom {\n  @apply after:pointer-events-none after:absolute after:bottom-0 after:left-0 after:hidden after:h-32 after:w-full after:bg-[linear-gradient(180deg,_transparent_10%,_hsl(var(--background))_70%)] md:after:block;\n}\n\n@layer base {\n  :root {\n    /* Custom CSS Variables */\n    --header-height: 4rem;\n    --tw-shadow-color: black;\n\n    /* CSS Variables for light theme */\n    --background: 0 0% 100%;\n    --backgroundButton: var(--persimmon);\n    --backgroundButtonDate: var(--karry);\n    --backgroundCard: var(--salmon);\n    --backgroundDatePicker: var(--seashellPeach);\n    --backgroundInvert: var(--white);\n    --backgroundHeader: var(--white);\n    --backgroundSecondary: var(--seashellPeach);\n    --backgroundSelect: var(--macaroniAndCheese);\n    --foreground: var(--matterhorn);\n\n    --card: 0 0% 100%;\n    --card-foreground: 0 0% 3.9%;\n\n    --popover: 0 0% 100%;\n    --popover-foreground: 0 0% 3.9%;\n\n    --primary: 0 0% 9%;\n    --primary-foreground: 0 0% 98%;\n\n    --secondary: 0 0% 96.1%;\n    --secondary-foreground: 0 0% 9%;\n\n    --tab: hsla(324, 13%, 23%, 0.6);\n    --tabActive: hsla(15, 91%, 61%, 0.6);\n    --tabActiveSecondary: hsla(28, 100%, 75%, 0.6);\n\n    --textInvert: var(--white);\n    --textPlaceholder: var(--macaroniAndCheese);\n    --textPrimary: var(--matterhorn);\n    --textSecondary: var(--persimmon);\n    --textThird: var(--salmon);\n\n    --pagination: hsl(var(--karry));\n    --paginationActive: var(--macaroniAndCheese);\n\n    --muted: 0 0% 96.1%;\n    --muted-foreground: 0 0% 45.1%;\n\n    --accent: 245 25% 54%;\n    --accent-foreground: 0 0% 9%;\n\n    --destructive: 0 84.2% 60.2%;\n    --destructive-foreground: 0 0% 98%;\n\n    --border: 0 0% 89.8%;\n    --input: 0 0% 89.8%;\n    --ring: 0 0% 3.9%;\n\n    --radius: 0.5rem;\n\n    --chart-1: 12 76% 61%;\n\n    --chart-2: 173 58% 39%;\n\n    --chart-3: 197 37% 24%;\n\n    --chart-4: 43 74% 66%;\n\n    --chart-5: 27 87% 67%;\n  }\n\n  .dark {\n    --background: 0 0% 100%;\n    --backgroundButton: var(--persimmon);\n    --backgroundButtonDate: var(--karry);\n    --backgroundCard: var(--salmon);\n    --backgroundDatePicker: var(--seashellPeach);\n    --backgroundInvert: var(--white);\n    --backgroundHeader: var(--white);\n    --backgroundSecondary: var(--seashellPeach);\n    --backgroundSelect: var(--macaroniAndCheese);\n    --foreground: var(--matterhorn);\n\n    --card: 0 0% 3.9%;\n    --card-foreground: 0 0% 98%;\n    --card-border: 0 0% 80%;\n\n    --tw-text-opacity: 0, 0%, 67%;\n\n    --popover: 0 0% 3.9%;\n    --popover-foreground: 0 0% 98%;\n\n    --primary: 0 0% 98%;\n    --primary-foreground: 0 0% 9%;\n\n    --secondary: 0 0% 14.9%;\n    --secondary-foreground: 0 0% 98%;\n\n    --tab: hsla(324, 13%, 23%, 0.6);\n    --tabActive: hsla(15, 91%, 61%, 0.6);\n    --tabActiveSecondary: hsla(28, 100%, 75%, 0.6);\n\n    --textInvert: var(--white);\n    --textPlaceholder: var(--macaroniAndCheese);\n    --textPrimary: var(--matterhorn);\n    --textSecondary: var(--persimmon);\n    --textThird: var(--salmon);\n\n    --pagination: hsl(var(--karry));\n    --paginationActive: var(--macaroniAndCheese);\n\n    --muted: 0 0% 14.9%;\n    --muted-foreground: 0 0% 63.9%;\n\n    --accent: 0 0% 14.9%;\n    --accent-foreground: 0 0% 98%;\n\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 0 0% 98%;\n\n    --border: 0 0% 14.9%;\n    --input: 0 0% 14.9%;\n    --ring: 0 0% 83.1%;\n    --chart-1: 220 70% 50%;\n    --chart-2: 160 60% 45%;\n    --chart-3: 30 80% 55%;\n    --chart-4: 280 65% 60%;\n    --chart-5: 340 75% 55%;\n  }\n\n  /* styles.css */\n  .collapsibleDropdown {\n    overflow: hidden;\n  }\n  .collapsibleDropdown[data-state=\"open\"] {\n    animation: slideDown 200ms ease-out;\n  }\n  .collapsibleDropdown[data-state=\"closed\"] {\n    animation: slideUp 200ms ease-out;\n  }\n\n  * {\n    @apply border-border;\n  }\n  body {\n    @apply min-h-svh w-full bg-background text-foreground;\n    font-family: \"Montserrat\", sans-serif;\n    font-optical-sizing: auto;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 122%;\n    font-style: normal;\n  }\n  body > #root {\n    @apply h-svh;\n  }\n\n  /* Prevent focus zoom on mobile devices */\n  @media screen and (max-width: 767px) {\n    input,\n    select,\n    textarea {\n      font-size: 16px !important;\n    }\n  }\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n  body {\n    @apply bg-background text-foreground;\n  }\n}\n\nbody,\nhtml {\n  overflow-y: scroll;\n  scrollbar-width: none;\n  color: \"red\";\n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\n\n.hide-horizontal-scrollbar {\n  overflow-x: scroll;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.hide-horizontal-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\npre {\n  font-family: Arial, serif;\n}\n\nhtml {\n  overflow: visible;\n}\n\n.swiper-pagination-bullet-active {\n  background-color: hsl(var(--matterhorn));\n}\n\n.myPagination {\n  display: flex;\n  justify-content: center;\n}\n\n.myPagination span {\n  background-color: var(--pagination);\n  margin: 0 0 !important;\n  border-radius: 1px;\n  transition: background 0.3s;\n}\n\n.myPagination span.swiper-pagination-bullet-active {\n  background-color: var(--paginationActive);\n}\n\n.object-bottom-left {\n  object-position: left bottom;\n}\n.scroll {\n  position: relative;\n  overflow: auto;\n  z-index: 100;\n}\n\n/* Стили для Webkit (Chrome, Safari) */\n.scroll::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.scroll::-webkit-scrollbar-button {\n  display: none;\n}\n\n.scroll::-webkit-scrollbar-track {\n  background: transparent;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n.scroll::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 5px;\n}\n\n.scroll::-webkit-scrollbar-thumb:hover {\n  background: hsl(var(--persimmon));\n  cursor: pointer;\n}\n\n.scroll::-webkit-scrollbar-corner {\n  background: var(--salmon);\n}\n\n/* Стили для Firefox */\n.scroll {\n  scrollbar-width: thin;\n  scrollbar-color: var(--salmon) transparent;\n  border-radius: 5px;\n}\n\n.toaster-custom {\n  z-index: 1000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
